/* ============================================================
   47X · GLOBAL REHYDRATION · pageshow / popstate / visibilitychange
   ============================================================
   Causa raíz documentada: Safari/Chrome restauran páginas desde
   bfcache cuando el usuario hace back/forward. Si se navegó MIENTRAS
   un overlay (menú, cart drawer) estaba abierto, body conserva la
   clase que bloquea `overflow:hidden` → al volver queda "trabado/negro"
   hasta refresh manual.

   Este handler corre ANTES de cualquier init y FUERZA reset del estado
   visual: overflow, opacity, classes, overlays, animaciones colgadas.
   ============================================================ */
(function rehydrate47() {
  var LOCK_CLASSES = [
    'is-loading',
    'is-transitioning',
    'page-loading',
    'page-transitioning',
    'menu-open',
    'drawer-open',
    'modal-open',
    'cart-open',
    'cart47-open',
    'hdr47-open',
    'mobile-menu-open'
  ];

  /* Helper · remueve el render-blocker de Horizon si quedó atascado.
     theme.liquid lo remueve en DOMContentLoaded · esto es un safety net
     para casos donde algo bloqueó ese script (slow JS, error temprano,
     bfcache restore que reinserta el link en el DOM del cache). */
  function killRenderBlocker() {
    try {
      var el = document.getElementById('view-transition-render-blocker');
      if (el && el.parentNode) {
        try { el.removeAttribute('blocking'); } catch (e) {}
        try { el.parentNode.removeChild(el); } catch (e) {}
      }
      /* También quita CUALQUIER link blocking=render rezagado, no solo el del id */
      document.querySelectorAll('link[blocking="render"]').forEach(function (l) {
        try { l.removeAttribute('blocking'); } catch (e) {}
        try { l.parentNode && l.parentNode.removeChild(l); } catch (e) {}
      });
    } catch (e) {}
  }

  /* Corre INMEDIATAMENTE · sin esperar evento · evita pantalla negra al primer paint */
  killRenderBlocker();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', killRenderBlocker, { once: true });
  }

  function reset() {
    try {
      var html = document.documentElement;
      var body = document.body;
      if (!body) return;

      /* 0. Render-blocker · prioridad absoluta · debe correr ANTES de cualquier
         otra cosa para que el browser pueda pintar inmediatamente */
      killRenderBlocker();

      /* 1. Overflow / opacity / visibility en root */
      try {
        html.style.overflow = '';
        html.style.opacity = '1';
        html.style.visibility = 'visible';
        body.style.overflow = '';
        body.style.opacity = '1';
        body.style.visibility = 'visible';
        body.style.pointerEvents = '';
      } catch (e) {}

      /* 2. Lock classes que bloquean scroll/render */
      try { LOCK_CLASSES.forEach(function (c) { body.classList.remove(c); }); } catch (e) {}

      /* 3. Cart drawer */
      try {
        var cart = document.querySelector('[data-cart47]');
        if (cart) {
          cart.classList.remove('is-open');
          cart.setAttribute('aria-hidden', 'true');
        }
      } catch (e) {}

      /* 4. Fullscreen menu */
      try {
        var menu = document.querySelector('.hdr47__overlay');
        if (menu) {
          menu.classList.remove('is-open');
          menu.setAttribute('aria-hidden', 'true');
          var toggle = document.querySelector('[data-hdr47-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      } catch (e) {}

      /* 5. Paneles vp47 / cb47 */
      try {
        document.querySelectorAll('[data-vp47-panel]:not([hidden]), [data-cb47-menu]:not([hidden])').forEach(function (p) {
          p.hidden = true;
        });
        document.querySelectorAll('[data-vp47-trigger][aria-expanded="true"]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });
      } catch (e) {}

      /* 6. Dialog / modal-overlay de Horizon */
      try {
        document.querySelectorAll('dialog[open], .modal-overlay[open], [aria-modal="true"][aria-hidden="false"]').forEach(function (m) {
          try { if (m.close) m.close(); } catch (e) {}
          m.removeAttribute('open');
          if (m.tagName === 'DIALOG' && m.open) m.open = false;
        });
      } catch (e) {}

      /* 7. fam47-gate · NO TOCAR · esta gate es la password gate del dashboard
         /pages/atletas y se muestra/oculta por el JS interno del dashboard.
         Si la cerramos aquí, en /pages/atletas la gate desaparece después de
         que el dashboard JS la mostró → pantalla en blanco. */

      /* 8. CRÍTICO · Reveal elements que ScrollTrigger no re-anima en bfcache.
         `.reveal { opacity:0 }` + `.reveal.in { opacity:1 }` — si .in no se aplica,
         la página parece negra/vacía. Force-add las clases visibles a TODO. */
      try {
        document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
          el.classList.add('in');
        });
        document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
          el.classList.add('is-revealed');
        });
        document.querySelectorAll('[data-reveal-z]:not(.is-revealed-z)').forEach(function (el) {
          el.classList.add('is-revealed-z');
        });
        /* Limpia inline opacity:0 / visibility:hidden / transform residuales de GSAP */
        document.querySelectorAll('[data-reveal], .reveal, .hdr47__nav-item, [data-hero] *, .he47__content, .he47__content *').forEach(function (el) {
          var s = el.style;
          if (s.opacity === '0' || s.opacity === '' && el.computedStyleMap) {/* noop */}
          if (s.opacity === '0') s.removeProperty('opacity');
          if (s.visibility === 'hidden') s.removeProperty('visibility');
          if (s.transform && s.transform.indexOf('translateY') !== -1) s.removeProperty('transform');
        });
      } catch (e) {}

      /* 9. Re-arranca videos autoplay. NO tocamos clases del hero · video sigue en su estado */
      try {
        document.querySelectorAll('video[autoplay]').forEach(function (v) {
          try {
            v.muted = true;
            /* Solo los que se están viendo. Antes despertaba TODOS, incluidos los que
               quedaron arriba o abajo del scroll, y se ponían a decodificar sin que
               nadie los viera. */
            var r = v.getBoundingClientRect();
            var vh = window.innerHeight || 800;
            if (r.bottom < 0 || r.top > vh) return;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } catch (e) {}
        });
      } catch (e) {}

      /* 10. Cart count refresh */
      try {
        if (window.CartCount47 && window.CartCount47.fetch) window.CartCount47.fetch();
      } catch (e) {}

      /* 11. Resize para que sliders/carruseles recalculen */
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    } catch (err) {
      /* Si algo explota · no detiene el flujo · siempre devolvemos el body visible */
      try {
        document.body.style.opacity = '1';
        document.body.style.visibility = 'visible';
        document.documentElement.style.overflow = '';
      } catch (e) {}
    }
  }

  /* pageshow · load inicial + bfcache restore (event.persisted true) */
  window.addEventListener('pageshow', function (event) {
    reset();
    if (event && event.persisted) {
      try { window.dispatchEvent(new CustomEvent('cart47:refresh')); } catch (e) {}
    }
  });

  /* popstate · back/forward sin bfcache */
  window.addEventListener('popstate', reset);

  /* visibilitychange · vuelve de otra pestaña/app */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reset();
  });

  /* pagehide · limpia classes ANTES de salir (preventivo) */
  window.addEventListener('pagehide', function () {
    LOCK_CLASSES.forEach(function (c) { document.body && document.body.classList.remove(c); });
    document.documentElement.style.overflow = '';
    if (document.body) document.body.style.overflow = '';
  });
})();

/* ============================================================
   47X100PRE — theme runtime
   Extraído de design/prototype.html y adaptado a Shopify.
   Defensivo: cada bloque chequea que su DOM exista antes de
   correr, para que las secciones se puedan migrar de a una.
   ============================================================ */
(function () {
  'use strict';

  /* ============ DEVICE TIER DETECTION · UN SOLO SWITCH ============
     Marca <html class="lite"> en móviles, equipos débiles o Save-Data.
     Marca <html class="reduced-motion"> cuando el usuario lo prefiere.
     Marca <html class="save-data"> cuando ahorro de datos está activo.
     El CSS .lite reduce blur/shadow/animations sin tocar la identidad. */
  (function detectTier() {
    var html = document.documentElement;
    var isMobile = window.matchMedia('(max-width: 760px)').matches;
    var lowMem = (navigator.deviceMemory || 8) <= 4;
    var lowCpu = (navigator.hardwareConcurrency || 8) <= 4;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection || {};
    var saveData = !!conn.saveData;
    var slowConn = conn.effectiveType && /(^|-)2g/.test(conn.effectiveType);
    /* .lite si: móvil, o equipo débil real (RAM y CPU bajos), o save-data, o conexión lenta */
    if (isMobile || (lowMem && lowCpu) || saveData || slowConn) {
      html.classList.add('lite');
    }
    if (reducedMotion) html.classList.add('reduced-motion');
    if (saveData) html.classList.add('save-data');
    /* Expone tier para que JS pueda usarlo */
    window.__tier47 = {
      isLite: html.classList.contains('lite'),
      reducedMotion: reducedMotion,
      saveData: saveData
    };
  })();

  var $ = function (s, ctx) { return (ctx || document).querySelector(s); };
  var $$ = function (s, ctx) { return Array.from((ctx || document).querySelectorAll(s)); };

  /* === Color de acento global ===
     Lee la variable CSS --accent del :root para que Canvas/Three.js sigan
     al switch de Modo Alerta. */
  function getAccentHex() {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--accent').trim();
      if (v.charAt(0) === '#' && (v.length === 7 || v.length === 4)) return v;
    } catch (e) {}
    return '#39FF14';
  }
  function getAccentInt() {
    var hex = getAccentHex().replace('#', '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    return parseInt(hex, 16);
  }
  function getAccentRgba(a) {
    var hex = getAccentHex().replace('#', '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    var r = parseInt(hex.slice(0,2), 16);
    var g = parseInt(hex.slice(2,4), 16);
    var b = parseInt(hex.slice(4,6), 16);
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
  }

  /* ============ Header scroll state ============ */
  function initHeaderScroll() {
    var nav = document.getElementById('nav');
    if (!nav) return;
    var onScroll = function () {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============ Mobile menu (burger) ============ */
  function initMobileMenu() {
    var burger = document.getElementById('burger');
    var mm = document.getElementById('mobileMenu');
    if (!burger || !mm) return;
    burger.addEventListener('click', function () {
      mm.classList.toggle('show');
      document.body.classList.toggle('menu-open');
    });
    $$('a', mm).forEach(function (a) {
      a.addEventListener('click', function () {
        mm.classList.remove('show');
        document.body.classList.remove('menu-open');
      });
    });
  }

  /* ============ Custom cursor (solo hover:hover) ============ */
  function initCursor() {
    var cur = document.querySelector('.cursor');
    var dot = document.querySelector('.cursor-dot');
    if (!cur || !dot) return;
    if (!window.matchMedia('(hover:hover)').matches) return;
    var cx = 0, cy = 0, tx = 0, ty = 0;
    window.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      dot.style.left = tx + 'px';
      dot.style.top = ty + 'px';
    });
    (function loop() {
      cx += (tx - cx) * 0.18;
      cy += (ty - cy) * 0.18;
      cur.style.left = cx + 'px';
      cur.style.top = cy + 'px';
      requestAnimationFrame(loop);
    })();
    $$('a,button,.card,.bento a,.hype-card').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cur.classList.add('grow'); });
      el.addEventListener('mouseleave', function () { cur.classList.remove('grow'); });
    });
  }

  /* ============ 3D tilt en tarjetas de producto ============ */
  function initCardTilt() {
    /* Tilt 3D global — skip en .lite, sin pointer fino, o reduced-motion (CAMBIO A: + .card47) */
    if (window.__tier47 && window.__tier47.isLite) return;
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    $$('.card, .card47').forEach(function (card) {
      var queued = false, lx = 0, ly = 0;
      function apply() {
        queued = false;
        var r = card.getBoundingClientRect();
        var px = (lx - r.left) / r.width - 0.5;
        var py = (ly - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (px * 9) + 'deg) rotateX(' + (-py * 9) + 'deg) translateZ(0)';
      }
      card.addEventListener('mousemove', function (e) {
        lx = e.clientX; ly = e.clientY;
        if (!queued) { queued = true; requestAnimationFrame(apply); }
      }, { passive: true });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(900px) rotateY(0) rotateX(0)';
      });
    });
  }

  /* ============ Card loop activo in-view · móvil/táctil ============
     .card47--live mientras la card está en viewport → look del hover de desktop en LOOP.
     IntersectionObserver TOGGLE (sin unobserve) · solo las cards en pantalla animan → cero costo fuera. Sin rAF.
     return SOLO en reduced-motion o en desktop con hover real · NADA de gate isLite. */
  function initCardScan47() {
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) return; /* desktop → usa :hover real, no esto */
    if (!('IntersectionObserver' in window)) return;
    var cards = $$('.card47');
    if (!cards.length) return;

    /* Toggle por entrada/salida (NO unobserve): card in-view → .card47--live · card fuera → quita la clase.
       Sin swap de imagen en móvil: la foto principal queda visible al instante (la 2ª foto solo se usa en :hover desktop). */
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var card = entries[i].target;
        if (entries[i].isIntersecting) {
          card.classList.add('card47--live');
        } else {
          card.classList.remove('card47--live');
        }
      }
    }, { threshold: 0.5 });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* ============ Form Código Atleta ============ */
  function initAthleteForm() {
    var form = document.getElementById('athleteForm');
    var msg = document.getElementById('athleteMsg');
    if (!form || !msg) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.innerHTML = '✅ <b style="color:var(--neon)">Código Atleta activado</b> — revisa tu correo, tu -10% ya va en camino';
      form.reset();
    });
  }

  /* 47X · GSAP/ScrollTrigger BAJO DEMANDA (FIX 6) · solo si la página tiene
     consumidores reales ([data-hero]/[data-parallax]). El stagger del menú
     ya vive en CSS, así que el menú NO depende de GSAP. */
  function loadGsapIfNeeded() {
    if (!document.querySelector('[data-hero], [data-parallax]')) return;
    if (window.gsap && window.ScrollTrigger) { initGsap(); return; }
    if (window.__gsap47Loading) return;
    window.__gsap47Loading = true;
    var base = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/';
    var s1 = document.createElement('script');
    s1.src = base + 'gsap.min.js';
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = base + 'ScrollTrigger.min.js';
      s2.onload = initGsap;
      document.head.appendChild(s2);
    };
    s1.onerror = function () { window.__gsap47Loading = false; };
    document.head.appendChild(s1);
  }

  /* ============ GSAP reveals + parallax + hero intro ============ */
  function initGsap() {
    if (!window.gsap || !window.ScrollTrigger) {
      // fallback: mostrar todo si GSAP no cargó
      $$('.reveal').forEach(function (e) { e.classList.add('in'); });
      $$('[data-hero]').forEach(function (e) {
        e.style.opacity = 1;
        e.style.transform = 'none';
      });
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });

    // intro del hero
    if ($$('[data-hero]').length) {
      gsap.set('[data-hero]', { y: 60, opacity: 0 });
      gsap.to('[data-hero]', { y: 0, opacity: 1, duration: 1.1, ease: 'power3.out', stagger: 0.12, delay: 0.2 });
    }

    // reveals
    $$('.reveal').forEach(function (el) {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 86%',
        onEnter: function () { el.classList.add('in'); },
        once: true
      });
    });

    // parallax layers
    $$('[data-parallax]').forEach(function (el) {
      var sp = parseFloat(el.dataset.parallax) || 0.1;
      gsap.to(el, {
        yPercent: sp * -100,
        ease: 'none',
        scrollTrigger: {
          trigger: el.closest('section') || el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    });

    loadThreeIfNeeded();
  }

  /* 47X · Three.js bajo demanda · se descarga SOLO si la página tiene #three-canvas
     y NO es móvil/táctil ni tier lite. Hoy ninguna página lo usa → 0 KB de Three. */
  function loadThreeIfNeeded() {
    if (!document.getElementById('three-canvas')) return;
    if (window.matchMedia('(max-width:760px)').matches || (navigator.maxTouchPoints || 0) > 0) return;
    if (window.__tier47 && window.__tier47.isLite) return;
    if (window.THREE) { initThree(); return; }
    if (window.__three47Loading) return;
    window.__three47Loading = true;
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    s.async = true;
    s.onload = initThree;
    s.onerror = function () { window.__three47Loading = false; };
    document.head.appendChild(s);
  }

  /* ============ THE 3D MOMENT — RENACER (Three.js) ============ */
  function initThree() {
    /* Gate explícito: jamás inicializar Three.js en móvil o táctil · cero calor */
    if (window.matchMedia('(max-width:760px)').matches || (navigator.maxTouchPoints || 0) > 0) return;
    var canvas = document.getElementById('three-canvas');
    if (!canvas || !window.THREE) return;
    /* .lite: Three.js COMPLETAMENTE apagado en móvil/equipo débil para no calentar */
    if (window.__tier47 && window.__tier47.isLite) return;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var isMobile = window.innerWidth < 760;

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
    /* PixelRatio cap más agresivo en .lite */
    var threeIsLite = window.__tier47 && window.__tier47.isLite;
    renderer.setPixelRatio(threeIsLite ? 1 : Math.min(window.devicePixelRatio, 1.5));
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
    camera.position.z = 6;

    function size() {
      var w = canvas.clientWidth, h = canvas.clientHeight;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }

    // Equirect gradient env para reflejos metálicos
    var ec = document.createElement('canvas'); ec.width = 512; ec.height = 256;
    var ex = ec.getContext('2d');
    var g = ex.createLinearGradient(0, 0, 0, 256);
    var accentHex = getAccentHex();
    var accentInt = getAccentInt();
    g.addColorStop(0, '#0a160e'); g.addColorStop(0.45, '#053a16'); g.addColorStop(0.5, accentHex);
    g.addColorStop(0.55, '#053a16'); g.addColorStop(1, '#02110a');
    ex.fillStyle = g; ex.fillRect(0, 0, 512, 256);
    ex.fillStyle = 'rgba(255,255,255,.85)'; ex.beginPath(); ex.arc(140, 70, 26, 0, 7); ex.fill();
    ex.fillStyle = getAccentRgba(0.6); ex.beginPath(); ex.arc(380, 120, 40, 0, 7); ex.fill();
    var envTex = new THREE.Texture(ec); envTex.mapping = THREE.EquirectangularReflectionMapping; envTex.needsUpdate = true;

    // Core crystal
    var geo = new THREE.IcosahedronGeometry(1.7, 1);
    var mat = new THREE.MeshStandardMaterial({
      color: 0x111114, metalness: 0.95, roughness: 0.22,
      envMap: envTex, envMapIntensity: 1.25, flatShading: true,
      emissive: 0x05300f, emissiveIntensity: 0.45
    });
    var core = new THREE.Mesh(geo, mat); scene.add(core);

    // Wireframe shell
    var wire = new THREE.Mesh(
      new THREE.IcosahedronGeometry(2.05, 1),
      new THREE.MeshBasicMaterial({ color: accentInt, wireframe: true, transparent: true, opacity: 0.18 })
    );
    scene.add(wire);

    // Partículas
    var COUNT = isMobile ? 500 : 1300;
    var pos = new Float32Array(COUNT * 3);
    for (var i = 0; i < COUNT; i++) {
      var r = 3 + Math.random() * 9;
      var th = Math.random() * Math.PI * 2;
      var ph = Math.acos(2 * Math.random() - 1);
      pos[i * 3] = r * Math.sin(ph) * Math.cos(th);
      pos[i * 3 + 1] = r * Math.sin(ph) * Math.sin(th);
      pos[i * 3 + 2] = r * Math.cos(ph);
    }
    var pgeo = new THREE.BufferGeometry();
    pgeo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    var points = new THREE.Points(pgeo, new THREE.PointsMaterial({ color: 0xECE5D8, size: 0.025, transparent: true, opacity: 0.7 }));
    scene.add(points);

    // Luces
    scene.add(new THREE.AmbientLight(0x222222, 0.6));
    var l1 = new THREE.PointLight(accentInt, 2.4, 40); l1.position.set(5, 3, 5); scene.add(l1);
    var l2 = new THREE.PointLight(0xffffff, 1.4, 40); l2.position.set(-6, -2, 4); scene.add(l2);
    var l3 = new THREE.PointLight(accentInt, 0.7, 30); l3.position.set(0, 6, -4); scene.add(l3);

    size();
    window.addEventListener('resize', size);

    var mx = 0, my = 0;
    window.addEventListener('mousemove', function (e) {
      mx = (e.clientX / window.innerWidth - 0.5);
      my = (e.clientY / window.innerHeight - 0.5);
    });

    var prog = 0;
    var words = document.querySelectorAll('.renacer .word');
    var trigger = document.getElementById('renacer') || document.querySelector('.renacer');
    if (trigger) {
      ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: 'bottom bottom',
        scrub: true,
        onUpdate: function (self) {
          prog = self.progress;
          words.forEach(function (w, i) {
            var seg = (prog - i / 3) * 3;
            var o = 1 - Math.abs(seg - 0.5) * 2;
            o = Math.max(0, Math.min(1, o));
            gsap.set(w, { opacity: o, y: (0.5 - Math.min(1, Math.max(0, seg))) * 40 });
          });
        }
      });
    }

    /* Pausa el render loop cuando el canvas sale del viewport */
    var threeInView = true;
    if ('IntersectionObserver' in window) {
      var threeIO = new IntersectionObserver(function (entries) {
        threeInView = entries[0].isIntersecting;
      }, { threshold: 0 });
      threeIO.observe(canvas);
    }

    var clock = new THREE.Clock();
    function render() {
      if (!threeInView) {
        /* Skip frame pero mantener loop vivo (cheap check) */
        requestAnimationFrame(render);
        return;
      }
      var t = clock.getElapsedTime();
      var speed = reduced ? 0 : 1;
      core.rotation.y = t * 0.25 * speed + prog * Math.PI * 2;
      core.rotation.x = t * 0.12 * speed + prog * 1.5;
      var s = 1 + prog * 0.9;
      core.scale.setScalar(s);
      wire.scale.setScalar(s * 1.02);
      wire.rotation.y = -t * 0.18 * speed - prog * 1.5;
      wire.rotation.x = t * 0.08 * speed;
      points.rotation.y = t * 0.04 * speed + prog * 0.6;
      camera.position.x += (mx * 1.6 - camera.position.x) * 0.05;
      camera.position.y += (-my * 1.2 - camera.position.y) * 0.05;
      camera.position.z = 6 - prog * 2.2;
      camera.lookAt(0, 0, 0);
      l1.intensity = 2.4 + Math.sin(t * 2) * 0.5;
      renderer.render(scene, camera);
      requestAnimationFrame(render);
    }
    render();
  }

  /* ============ Boot ============ */
  function boot() {
    initHeaderScroll();
    initMobileMenu();
    initCursor();
    initCardTilt();
    initCardScan47();
    initAthleteForm();
    initHero();
    initQuickBuy();
    initContadorPro();
    initMiniCart();
    initAddToMini();
    initRuleta();
    initBackLink();
    initRayosXCarrusel();
    initHourlyRotation();
    initEspecimenesSlider();
    initAtletaGate();
    initMenuFullscreen();
    initCartCountWatcher();
    initCineReveals();
    initSlot47();
    initStickyBuyMobile47();
  }

  /* ============ CINEMATIC REVEALS · IntersectionObserver global ============
     Cualquier elemento con [data-cine] o clase .cine-reveal entra con fade/
     slide/scale; hijos con [data-cine-child] hacen stagger via --cine-i.
     Performance: una sola IO; unobserve al primer hit. */
  function initCineReveals() {
    if (!('IntersectionObserver' in window)) return;
    var nodes = document.querySelectorAll('[data-cine], .cine-reveal');
    if (!nodes.length) return;

    /* Pre-pre-asignar --cine-i en hijos */
    nodes.forEach(function (root) {
      var kids = root.querySelectorAll('[data-cine-child]');
      kids.forEach(function (k, i) { k.style.setProperty('--cine-i', i); });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-cine');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    nodes.forEach(function (n) {
      // Secciones MUY altas (>=1500px) nunca alcanzarían el threshold 5% en un
      // viewport mobile típico (900px) · las marcamos como is-cine al instante
      // sin observerlas (caso típico: .atleta47 desbloqueada con 30 productos).
      if (n.offsetHeight >= 1500) {
        n.classList.add('is-cine');
        return;
      }
      io.observe(n);
    });
  }

  /* ============ MENÚ FULLSCREEN HUD · open/close + focus trap + ESC ============ */
  function initMenuFullscreen() {
    var hdr = document.querySelector('[data-hdr47]');
    var overlay = document.querySelector('[data-hdr47-overlay]');
    if (!hdr || !overlay) return;
    var toggle = document.querySelector('[data-hdr47-toggle]');
    var closeBtns = document.querySelectorAll('[data-hdr47-close]');
    var navLinks = overlay.querySelectorAll('.hdr47__nav-link, .hdr47__sub-link, .hdr47__o-close');
    var subsToggles = overlay.querySelectorAll('[data-hdr47-subs-toggle]');
    var lastFocus = null;
    var isOpen = false;
    var rainCanvas = overlay.querySelector('[data-hdr47-rain]');
    var rain = rainCanvas ? createMenuMatrix(overlay, rainCanvas) : { start: function () {}, stop: function () {} };

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hdr47-open');
      rain.start();
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      /* FIX 6 · stagger del menú ahora en CSS (.hdr47__overlay.is-open .hdr47__nav-item:nth-child) · sin GSAP */
      /* Focus al primer link tras micro delay */
      setTimeout(function () {
        var first = overlay.querySelector('.hdr47__nav-link');
        if (first) first.focus();
      }, 220);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hdr47-open');
      rain.stop();
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      /* cerrar submenús abiertos */
      overlay.querySelectorAll('[data-hdr47-subs-toggle][aria-expanded="true"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var subs = t.closest('.hdr47__nav-item').querySelector('.hdr47__subs');
        if (subs) { subs.classList.remove('is-open'); subs.hidden = true; }
      });
      /* devuelve foco al botón menú */
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (toggle) toggle.addEventListener('click', function () {
      /* Derivar estado del DOM, NO de closure · evita state desync post-bfcache.
         rehydrate47 step 4 limpia `.is-open` del overlay en pageshow pero la closure
         var isOpen quedaba stuck en true → primer tap cerraba el DOM-ya-cerrado (no-op)
         y obligaba a un segundo tap para abrir. */
      var openInDOM = overlay.classList.contains('is-open');
      if (openInDOM) { isOpen = true; close(); } else { isOpen = false; open(); }
    });
    closeBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        /* solo cerrar; el link de logo dejará navegar también */
        if (b.tagName !== 'A') e.preventDefault();
        close();
      });
    });

    /* ESC */
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        /* focus trap básico */
        var focusables = overlay.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });

    /* Submenús: acordeón animado · al abrir uno se colapsan los otros (CAMBIO 3) */
    function setSubs(t, openIt) {
      var item = t.closest('.hdr47__nav-item');
      var subs = item ? item.querySelector('.hdr47__subs') : null;
      if (!subs) return;
      t.setAttribute('aria-expanded', openIt ? 'true' : 'false');
      if (openIt) {
        subs.hidden = false;
        requestAnimationFrame(function () { subs.classList.add('is-open'); });
      } else {
        subs.classList.remove('is-open');
        var done = function (e) {
          if (e && e.propertyName && e.propertyName !== 'max-height') return;
          subs.hidden = true;
          subs.removeEventListener('transitionend', done);
        };
        subs.addEventListener('transitionend', done);
        setTimeout(function () { if (!subs.classList.contains('is-open') && !subs.hidden) subs.hidden = true; }, 480);
      }
    }
    subsToggles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = t.getAttribute('aria-expanded') !== 'true';
        if (willOpen) {
          subsToggles.forEach(function (o) { if (o !== t && o.getAttribute('aria-expanded') === 'true') setSubs(o, false); });
        }
        setSubs(t, willOpen);
      });
    });

    /* Header sticky compact al hacer scroll + medición dinámica de la altura del anuncio.
       · IntersectionObserver del anuncio → toggla is-scrolled SOLO cuando ya salió del viewport
         (evita overlap durante la transición vs el viejo `scrollY > 20` que activaba prematuro)
       · ResizeObserver del anuncio → mide su altura real y setea --anuncio-h en el HUD
         (antes era hardcoded 88px y dejaba gap cuando el anuncio era más bajo) */
    var anuncio = document.querySelector('section.anuncio');
    if (anuncio) {
      function syncAnuncioHeight() {
        var h = Math.round(anuncio.getBoundingClientRect().height);
        if (h > 0) hdr.style.setProperty('--anuncio-h', h + 'px');
      }
      syncAnuncioHeight();
      if ('ResizeObserver' in window) {
        new ResizeObserver(syncAnuncioHeight).observe(anuncio);
      } else {
        window.addEventListener('resize', syncAnuncioHeight, { passive: true });
      }
      if ('IntersectionObserver' in window) {
        var ioHdr = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            hdr.classList.toggle('is-scrolled', !e.isIntersecting);
          });
        }, { threshold: 0, rootMargin: '0px' });
        ioHdr.observe(anuncio);
      } else {
        var onScroll = function () {
          hdr.classList.toggle('is-scrolled', window.scrollY > 20);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }

    /* FIX · botón "VOLVER" pegado al header (el --header-group-height quedaba mal
       calculado y dejaba un hueco ancho). Medimos el borde inferior REAL del header
       y la posición natural del botón → margen exacto, sin importar si el anuncio va fijo o en flujo. */
    (function () {
      var hdr47 = document.querySelector('.hdr47');
      var wrap = document.querySelector('.back47-wrap');
      if (!hdr47 || !wrap) return;
      var root = document.documentElement;
      function fitBack47() {
        if ((window.scrollY || window.pageYOffset || 0) > 4) return; /* solo ajusta en el tope de la página */
        var cur = parseFloat(getComputedStyle(wrap).marginTop) || 0;
        var natural = wrap.getBoundingClientRect().top - cur;         /* posición del botón con margen 0 */
        var headerBottom = hdr47.getBoundingClientRect().bottom;      /* borde inferior real del header (anuncio + nav) */
        var needed = Math.max(0, Math.round(headerBottom - natural));
        if (Math.abs(needed - cur) > 1) root.style.setProperty('--back47-offset', needed + 'px');
      }
      fitBack47();
      window.addEventListener('load', fitBack47);
      window.addEventListener('resize', function () { clearTimeout(wrap._b47t); wrap._b47t = setTimeout(fitBack47, 150); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitBack47);
    })();
  }

  /* Watcher de cart count · refresca on add via MiniCart47 + initial fetch */
  function initCartCountWatcher() {
    var counts = document.querySelectorAll('[data-cart-count]');
    if (!counts.length) return;

    function setCount(n) {
      counts.forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('is-active', n > 0);
      });
    }

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCount(cart.item_count || 0); })
        .catch(function () {});
    }
    refresh();
    /* Expose para que MiniCart u otros lo puedan llamar */
    window.CartCount47 = { refresh: refresh, set: setCount };
  }

  /* ============ ÁREA ATLETAS · gate por contraseña (default AMO47) ============
     Submit success → redirect a /pages/zona-secreta (no inline reveal).
     localStorage queda como marker para futuras integraciones (no es gate real). */
  function initAtletaGate() {
    var root = document.querySelector('[data-atleta47]');
    if (!root) return;
    var password = (root.dataset.password || 'AMO47');
    var redirectUrl = (root.dataset.redirectUrl || '/pages/zona-secreta');
    var form = root.querySelector('[data-atleta47-form]');
    var input = root.querySelector('[data-atleta47-input]');
    var errEl = root.querySelector('[data-atleta47-error]');
    var lsKey = 'atleta47.unlocked';

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = (input && input.value || '').trim();
        if (errEl) errEl.hidden = true;
        if (val === password) {
          try { localStorage.setItem(lsKey, '1'); } catch (er) {}
          window.location.href = redirectUrl;
        } else {
          if (errEl) errEl.hidden = false;
          form.classList.add('is-shake');
          setTimeout(function () { form.classList.remove('is-shake'); }, 420);
          if (input) { input.focus(); input.select(); }
        }
      });
    }
  }

  /* ============ ROTACIÓN HORARIA ·
     Reordena cards en cualquier contenedor con data-rotate-hourly="true"
     usando new Date().getHours() como semilla. Los productos siguen siendo
     los mismos pero el orden visible cambia por hora del cliente. */
  function initHourlyRotation() {
    var grids = document.querySelectorAll('[data-rotate-hourly="true"]');
    grids.forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.children);
      if (cards.length < 2) return;
      var hour = new Date().getHours();
      var offset = hour % cards.length;
      if (offset === 0) return;
      var reordered = cards.slice(offset).concat(cards.slice(0, offset));
      var frag = document.createDocumentFragment();
      reordered.forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
    });
  }

  /* ============ Especímenes slider · arrows + scroll suave ============ */
  function initEspecimenesSlider() {
    document.querySelectorAll('[data-especim47]').forEach(function (root) {
      var track = root.querySelector('[data-especim-track]');
      var prev = root.querySelector('[data-especim-prev]');
      var next = root.querySelector('[data-especim-next]');
      if (!track) return;

      function scrollByCard(dir) {
        var first = track.children[0];
        if (!first) return;
        var amount = first.offsetWidth + 18;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { scrollByCard(1); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { scrollByCard(-1); e.preventDefault(); }
      });
    });
  }

  /* ============ RAYOS X CARRUSEL · auto-scan, transform/opacity only ============ */
  function initRayosXCarrusel() {
    var roots = document.querySelectorAll('[data-rxc47]');
    if (!roots.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    roots.forEach(function (root) {
      var slidesWrap = root.querySelector('[data-rxc-slides]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var prev = root.querySelector('[data-rxc-prev]');
      var next = root.querySelector('[data-rxc-next]');
      var bulletsEl = root.querySelector('[data-rxc-bullets]');
      var numEl = root.querySelector('[data-rxc-num]');
      var cfgEl = root.querySelector('[data-rxc-config]');
      if (!slides.length) return;

      var cfg = {};
      try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) {}
      var speedMs = (cfg.speed || 5) * 1000;
      var idx = 0;
      var timer = null;
      var inView = true;

      /* Build bullets */
      if (bulletsEl) {
        var html = '';
        for (var i = 0; i < slides.length; i++) {
          html += '<button type="button" class="rxc47__bullet' + (i === 0 ? ' is-active' : '') + '" data-rxc-bullet="' + i + '" aria-label="Pieza ' + (i + 1) + '"></button>';
        }
        bulletsEl.innerHTML = html;
      }

      function fmtNum(n) {
        var s = '00' + (n + 1);
        return '#' + s.slice(-3);
      }
      function go(target) {
        if (target < 0) target = slides.length - 1;
        if (target >= slides.length) target = 0;
        slides[idx].classList.remove('is-active');
        if (bulletsEl) {
          var oldB = bulletsEl.querySelector('[data-rxc-bullet="' + idx + '"]');
          if (oldB) oldB.classList.remove('is-active');
        }
        idx = target;
        slides[idx].classList.add('is-active');
        if (numEl) numEl.textContent = fmtNum(idx);
        if (bulletsEl) {
          var newB = bulletsEl.querySelector('[data-rxc-bullet="' + idx + '"]');
          if (newB) newB.classList.add('is-active');
        }
      }
      function step() { go(idx + 1); }
      function start() {
        if (timer || reduced || slides.length < 2) return;
        /* Móvil/táctil: setInterval mucho más lento para no calentar */
        var isMobileTick = window.matchMedia('(max-width:760px)').matches || (navigator.maxTouchPoints || 0) > 0;
        var tickMs = isMobileTick ? Math.max(speedMs, 12000) : speedMs;
        timer = setInterval(step, tickMs);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      /* Init num + controls */
      if (numEl) numEl.textContent = fmtNum(0);
      if (prev) prev.addEventListener('click', function () { stop(); go(idx - 1); start(); });
      if (next) next.addEventListener('click', function () { stop(); go(idx + 1); start(); });
      if (bulletsEl) {
        bulletsEl.addEventListener('click', function (e) {
          var b = e.target.closest('[data-rxc-bullet]');
          if (!b) return;
          stop(); go(parseInt(b.dataset.rxcBullet, 10)); start();
        });
      }

      /* Pausa al pasar mouse (UX) */
      if (slidesWrap) {
        slidesWrap.addEventListener('mouseenter', stop);
        slidesWrap.addEventListener('mouseleave', function () { if (inView) start(); });
      }

      /* IntersectionObserver: pause offscreen */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            inView = e.isIntersecting;
            root.classList.toggle('is-offscreen', !inView);
            if (inView) start(); else stop();
          });
        }, { threshold: 0, rootMargin: '50px 0px' });
        io.observe(root);
      } else {
        start();
      }
    });
  }

  /* ============ MENU MATRIX · lluvia del overlay del menú (CAMBIO 2) ============
     Mismo patrón que createHeroMatrix (drops/fillText/fade/frame-divisor/getAccentRgba/dpr cap)
     pero SÍ corre en móvil con font mayor = menos columnas. La arranca open()/la para close():
     JAMÁS corre con el menú cerrado. reduced-motion → sin lluvia. Lee --accent (flipea con Modo Alerta). */
  function createMenuMatrix(host, canvas) {
    if (!canvas || window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
      return { start: function () {}, stop: function () {} };
    }
    var ctx = canvas.getContext('2d', { alpha: true });
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var w = 0, h = 0, columns = 0, drops = [], rafId = 0, running = false, fontSize = 15;
    var chars = 'アカサタナハマヤラワ47X四十七0123456789ｱｶｻﾀﾅﾊﾐ';
    var frameSkip = 0, FRAME_DIVISOR = 2;

    function resize() {
      var r = host.getBoundingClientRect();
      fontSize = (window.innerWidth < 760 ? 20 : 15) * dpr;
      w = canvas.width = Math.max(1, Math.floor(r.width * dpr));
      h = canvas.height = Math.max(1, Math.floor(r.height * dpr));
      canvas.style.width = r.width + 'px';
      canvas.style.height = r.height + 'px';
      columns = Math.max(1, Math.floor(w / fontSize));
      drops = new Array(columns);
      for (var i = 0; i < columns; i++) drops[i] = Math.random() * (h / fontSize) * 0.5;
    }
    function step() {
      if (!running) return;
      frameSkip = (frameSkip + 1) % FRAME_DIVISOR;
      if (frameSkip !== 0) { rafId = requestAnimationFrame(step); return; }
      ctx.fillStyle = 'rgba(5,5,5,0.16)';
      ctx.fillRect(0, 0, w, h);
      ctx.font = fontSize + 'px monospace';
      ctx.fillStyle = getAccentRgba(0.85);
      for (var i = 0; i < columns; i++) {
        var ch = chars.charAt(Math.floor(Math.random() * chars.length));
        var yPos = drops[i] * fontSize;
        ctx.fillText(ch, i * fontSize, yPos);
        if (yPos > h && Math.random() > 0.975) drops[i] = 0;
        drops[i]++;
      }
      rafId = requestAnimationFrame(step);
    }
    function start() {
      if (running) return;
      resize();
      running = true;
      rafId = requestAnimationFrame(step);
    }
    function stop() {
      running = false;
      if (rafId) { cancelAnimationFrame(rafId); rafId = 0; }
      if (ctx && w && h) ctx.clearRect(0, 0, w, h);
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { if (running) resize(); }).observe(host);
    }
    return { start: start, stop: stop };
  }

  /* ============ HERO MATRIX BG · lluvia + relámpagos + glitch ligero ============
     Re-usa la pausa offscreen del initHero (.is-offscreen). Lee --accent
     dinámicamente para flipear con Modo Alerta. */
  function createHeroMatrix(hero, canvas) {
    /* Gate explícito móvil/táctil: matrix jamás corre en cel */
    if (window.matchMedia('(max-width:760px)').matches || (navigator.maxTouchPoints || 0) > 0) {
      return { start: function () {}, stop: function () {} };
    }
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
      return { start: function () {}, stop: function () {} };
    }
    /* .lite: matrix COMPLETAMENTE apagado en móvil/equipo débil */
    if (window.__tier47 && window.__tier47.isLite) {
      return { start: function () {}, stop: function () {} };
    }
    var ctx = canvas.getContext('2d', { alpha: true });
    var isMobile = window.innerWidth < 760;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var w = 0, h = 0;
    var fontSize = (isMobile ? 12 : 14) * dpr;
    var columns = 0;
    var drops = [];
    var rafId = 0;
    var running = false;
    var inited = false;
    var chars = '47X100PRE四十七CONQUISTA01▸◢◣◤◥0';
    var frameSkip = 0;
    var FRAME_DIVISOR = 2; /* ~30 fps */

    /* Lightning state */
    var nextBolt = performance.now() + 4000 + Math.random() * 4000;
    var bolt = null;

    function resize() {
      var r = hero.getBoundingClientRect();
      w = canvas.width = Math.max(1, Math.floor(r.width * dpr));
      h = canvas.height = Math.max(1, Math.floor(r.height * dpr));
      canvas.style.width = r.width + 'px';
      canvas.style.height = r.height + 'px';
      columns = Math.floor(w / fontSize);
      drops = new Array(columns);
      for (var i = 0; i < columns; i++) {
        drops[i] = Math.random() * (h / fontSize) * 0.5;
      }
    }

    function buildBolt() {
      var x = Math.random() * w;
      var pts = [{ x: x, y: 0 }];
      var y = 0;
      while (y < h) {
        y += 30 * dpr + Math.random() * 30 * dpr;
        x += (Math.random() - 0.5) * 80 * dpr;
        pts.push({ x: x, y: y });
      }
      return { pts: pts, life: 220, born: performance.now() };
    }

    function drawBolt(now) {
      if (!bolt) return;
      var age = now - bolt.born;
      if (age > bolt.life) { bolt = null; return; }
      var alpha = 1 - age / bolt.life;
      ctx.strokeStyle = getAccentRgba(0.85 * alpha);
      ctx.shadowColor = getAccentRgba(0.7 * alpha);
      ctx.shadowBlur = 18 * dpr;
      ctx.lineWidth = 1.4 * dpr;
      ctx.beginPath();
      ctx.moveTo(bolt.pts[0].x, bolt.pts[0].y);
      for (var i = 1; i < bolt.pts.length; i++) ctx.lineTo(bolt.pts[i].x, bolt.pts[i].y);
      ctx.stroke();
      ctx.shadowBlur = 0;
    }

    function step() {
      if (!running) return;
      frameSkip = (frameSkip + 1) % FRAME_DIVISOR;
      if (frameSkip !== 0) {
        rafId = requestAnimationFrame(step);
        return;
      }
      /* Fade trail */
      ctx.fillStyle = 'rgba(0,0,0,0.12)';
      ctx.fillRect(0, 0, w, h);

      /* Matrix chars */
      ctx.font = fontSize + 'px monospace';
      ctx.fillStyle = getAccentRgba(0.55);
      for (var i = 0; i < columns; i++) {
        var ch = chars.charAt(Math.floor(Math.random() * chars.length));
        var yPos = drops[i] * fontSize;
        ctx.fillText(ch, i * fontSize, yPos);
        if (yPos > h && Math.random() > 0.975) drops[i] = 0;
        drops[i]++;
      }

      /* Lightning bolt */
      var now = performance.now();
      if (!bolt && now > nextBolt) {
        bolt = buildBolt();
        nextBolt = now + 5000 + Math.random() * 7000;
      }
      drawBolt(now);

      rafId = requestAnimationFrame(step);
    }

    var resizeTimer = 0;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resize, 200);
    }

    return {
      start: function () {
        if (running) return;
        if (!inited) { resize(); window.addEventListener('resize', onResize); inited = true; }
        running = true;
        rafId = requestAnimationFrame(step);
      },
      stop: function () {
        running = false;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = 0;
      }
    };
  }

  /* ============ MINI CART · drawer + ajax /cart ============ */
  function initMiniCart() {
    var root = document.querySelector('[data-cart47]');
    if (!root) return;
    var body = root.querySelector('[data-cart47-body]');
    var subtotalEl = root.querySelector('[data-cart47-subtotal]');

    function fmt(cents) {
      return '$' + Math.round((cents || 0) / 100).toLocaleString('es-MX');
    }
    function open() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart47-open');
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart47-open');
    }

    function render(cart) {
      var discountsEl = root.querySelector('[data-cart47-discounts]');
      var savingsEl = root.querySelector('[data-cart47-savings]');
      var savingsValEl = root.querySelector('[data-cart47-savings-value]');
      var originalEl = root.querySelector('[data-cart47-original]');

      if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);

      /* Subtotal compare + ahorro total · solo si es un ahorro REAL (evita "Ahorras $0") */
      var totalSavings = (cart.original_total_price || 0) - (cart.total_price || 0);
      if (totalSavings >= 100) {
        if (originalEl) {
          originalEl.textContent = fmt(cart.original_total_price);
          originalEl.hidden = false;
        }
        if (savingsEl) savingsEl.hidden = false;
        if (savingsValEl) savingsValEl.textContent = fmt(totalSavings);
      } else {
        if (originalEl) originalEl.hidden = true;
        if (savingsEl) savingsEl.hidden = true;
      }

      /* Lista de descuentos aplicados (cart-level) */
      var cartDiscounts = (cart.cart_level_discount_applications || []).filter(function (d) {
        return d && (d.total_allocated_amount > 0 || d.title);
      });
      if (discountsEl) {
        if (cartDiscounts.length > 0) {
          discountsEl.innerHTML = cartDiscounts.map(function (d) {
            return ''
              + '<div class="cart47__discount">'
              +   '<span class="cart47__discount-glyph" aria-hidden="true">▸</span>'
              +   '<span class="cart47__discount-title">' + (d.title || 'Descuento') + '</span>'
              +   '<span class="cart47__discount-amount">−' + fmt(d.total_allocated_amount || 0) + '</span>'
              + '</div>';
          }).join('');
          discountsEl.hidden = false;
        } else {
          discountsEl.innerHTML = '';
          discountsEl.hidden = true;
        }
      }

      /* === ESCALERA DE RECOMPENSAS ===
         Hitos definidos en data-cart47-hitos: "umbral|etiqueta|handle;..."
         El relleno es proporcional al hito MÁS ALTO, así la barra representa
         el recorrido completo y no solo el siguiente paso.

         Los regalos NO se agregan solos mientras data-cart47-regalos-activos
         sea false: meter un producto al carrito sin un descuento que lo deje
         en $0 haría que el cliente lo pague. */
      var fsThreshold = parseInt(root.dataset.cart47FsThreshold || '139900', 10);
      var fsCurrent = cart.total_price || 0;
      var fsRemaining = Math.max(fsThreshold - fsCurrent, 0);
      var isEmpty = !cart.items || cart.items.length === 0;

      (function escalera() {
        var caja = root.querySelector('[data-cart47-esc]');
        if (!caja) return;
        var crudo = (root.dataset.cart47Hitos || '').trim();
        if (!crudo) { caja.hidden = true; return; }

        var hitos = crudo.split(';').map(function (fila) {
          var p = fila.split('|');
          var monto = parseInt((p[0] || '').trim(), 10);
          if (!monto || isNaN(monto)) return null;
          return { monto: monto, label: (p[1] || '').trim(), regalo: (p[2] || '').trim() };
        }).filter(Boolean).sort(function (a, b) { return a.monto - b.monto; });
        if (!hitos.length) { caja.hidden = true; return; }
        caja.hidden = false;

        var tope = hitos[hitos.length - 1].monto;
        var pct = Math.max(0, Math.min(100, Math.round(fsCurrent / tope * 100)));
        var fill = root.querySelector('[data-cart47-esc-fill]');
        if (fill) fill.style.transform = 'scaleX(' + (pct / 100) + ')';

        var lista = root.querySelector('[data-cart47-esc-hitos]');
        if (lista) {
          lista.innerHTML = hitos.map(function (h) {
            var on = fsCurrent >= h.monto;
            return '<li class="cart47__esc-hito' + (on ? ' is-on' : '') + '">'
              + '<span class="cart47__esc-dot">'
              + '<svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#060606" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'
              + '</span>'
              + '<span class="cart47__esc-lbl">' + (h.label || fmt(h.monto)) + '</span>'
              + '</li>';
          }).join('');
        }

        var msg = root.querySelector('[data-cart47-esc-msg]');
        if (msg) {
          var sig = null;
          for (var i = 0; i < hitos.length; i++) { if (fsCurrent < hitos[i].monto) { sig = hitos[i]; break; } }
          if (isEmpty) {
            msg.textContent = 'Agrega productos y desbloquea beneficios';
          } else if (sig) {
            msg.innerHTML = 'Te faltan <b>' + fmt(sig.monto - fsCurrent) + '</b> para <b>' + (sig.label || 'el siguiente beneficio') + '</b>';
          } else {
            msg.innerHTML = '<span class="is-win"><b>Desbloqueaste todo</b></span>';
          }
        }

        /* Auto-regalo: apagado hasta que exista el descuento que lo deja en $0 */
        if (root.dataset.cart47RegalosActivos === 'true') {
          hitos.forEach(function (h) {
            if (!h.regalo || fsCurrent < h.monto) return;
            var yaEsta = (cart.items || []).some(function (it) { return it.handle === h.regalo; });
            if (yaEsta) return;
            /* pendiente: /cart/add.js del regalo cuando el descuento esté creado */
          });
        }
      })();

      /* === RESUMEN DE COMPRA · ENVÍO · PLAZO ===
         Todo sale del carrito real. El envío se dice ANTES del checkout porque
         el +$119 apareciendo en el último paso es motivo de abandono. El plazo
         cambia según lo que se lleve: los drops tardan más y hay que decirlo. */
      var SHIP_COST = 11900;
      var q = function (sel) { return root.querySelector(sel); };

      var sumProd = q('[data-cart47-sum-productos]');
      var sumEnv  = q('[data-cart47-sum-envio]');
      var sumDesc = q('[data-cart47-sum-desc]');
      var sumDescV= q('[data-cart47-sum-desc-v]');
      var sumKlbl = q('[data-cart47-sum-klabel]');

      if (sumProd) sumProd.textContent = fmt(cart.original_total_price || cart.total_price || 0);
      if (sumKlbl) sumKlbl.textContent = 'Productos (' + (cart.item_count || 0) + ')';

      var ahorro = (cart.original_total_price || 0) - (cart.total_price || 0);
      if (sumDesc) {
        if (ahorro > 0) { sumDesc.hidden = false; if (sumDescV) sumDescV.textContent = '−' + fmt(ahorro); }
        else sumDesc.hidden = true;
      }
      if (sumEnv) {
        sumEnv.textContent = fsRemaining > 0 ? fmt(SHIP_COST) : 'Gratis';
        sumEnv.style.color = fsRemaining > 0 ? '' : 'var(--accent)';
      }

      /* Plazo: manda el más largo de lo que haya en la bolsa — nunca se promete de menos */
      var etaBox = q('[data-cart47-eta]'), etaTxt = q('[data-cart47-eta-txt]');
      if (etaBox && etaTxt) {
        if (isEmpty) { etaBox.hidden = true; }
        else {
          var esDrop = (cart.items || []).some(function (it) {
            var tg = (it.product_tags || []).map(function (t) { return String(t).toLowerCase(); });
            return tg.indexOf('anime-jogger-drop') > -1 || tg.indexOf('p3h-drop') > -1;
          });
          etaTxt.textContent = esDrop
            ? 'Tu pedido estará listo en 15–21 días hábiles'
            : 'Entrega de 4 a 12 días hábiles';
          etaBox.hidden = false;
        }
      }

      if (!cart.items || cart.items.length === 0) {
        try { pintarFold(cart); } catch (e) {}

      /* El total dentro del botón: el cliente ve QUÉ va a pagar sin buscarlo */
      try {
        var ctaT = root.querySelector('[data-cart47-cta-total]');
        if (ctaT) ctaT.textContent = (cart.item_count || 0) ? '· ' + fmt(cart.total_price || 0) : '';
      } catch (e) {}

      /* === UPSELL DEL PACK (uno solo) ===
         Solo con 1 o 2 piezas del drop en la bolsa. Con 3+ el cliente ya está
         en volumen y ofrecerlo sobra; si se muestra, se calla el carrusel para
         no apilar dos ofertas compitiendo. */
      try {
        var pu = root.querySelector('[data-cart47-packup]');
        if (pu) {
          var ofertas = [];
          try { ofertas = JSON.parse(root.dataset.cart47Packs || '[]') || []; } catch (e0) { ofertas = []; }
          if (!ofertas.length && root.dataset.cart47PackTag) {
            ofertas = [{ tag: root.dataset.cart47PackTag, url: root.dataset.cart47PackUrl,
                         titulo: root.dataset.cart47PackTitulo, precio: root.dataset.cart47PackPrecio,
                         ahorro: root.dataset.cart47PackAhorro }];
          }
          var elegida = null;
          ofertas.forEach(function (of) {
            if (elegida || !of || !of.tag) return;
            var tg0 = String(of.tag).toLowerCase(), n0 = 0;
            (cart.items || []).forEach(function (it) {
              var tg = (it.product_tags || []).map(function (t) { return String(t).toLowerCase(); });
              if (tg.indexOf(tg0) > -1) n0 += (it.quantity || 0);
            });
            if (n0 >= 1 && n0 <= 2) elegida = of;
          });
          var aplica = !!elegida;
          pu.hidden = !aplica;
          if (aplica) {
            pu.href = elegida.url || '/';
            var pt = root.querySelector('[data-cart47-packup-t]');
            var ps = root.querySelector('[data-cart47-packup-s]');
            if (pt) pt.textContent = elegida.titulo || 'ARMA TU PACK DE 3';
            if (ps) ps.textContent = '3 por ' + (elegida.precio || '') + ' · ahorras ' + (elegida.ahorro || '');
          }
          var carrusel = root.querySelector('[data-cart47-upsell]');
          if (carrusel && aplica) carrusel.hidden = true;
        }
      } catch (e) {}
        body.innerHTML =
          '<div class="cart47__empty">' +
            '<div class="cart47__empty-glyph" aria-hidden="true">▸</div>' +
            '<div class="cart47__empty-text">Tu bolsa está vacía</div>' +
            '<div class="cart47__empty-sub">Empieza por tu primera pieza</div>' +
          '</div>';
        return;
      }

      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? (it.image.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png')) : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var lineDiscounts = it.line_level_discount_allocations || [];
        var lineSavings = (it.original_line_price || 0) - (it.final_line_price || 0);
        var hasDiscount = lineSavings > 0;
        var priceHtml = hasDiscount
          ? '<span class="cart47__item-price-compare">' + fmt(it.original_line_price) + '</span>'
            + '<span class="cart47__item-price">' + fmt(it.final_line_price) + '</span>'
          : '<span class="cart47__item-price">' + fmt(it.final_line_price) + '</span>';
        var discountTags = lineDiscounts.map(function (d) {
          var title = (d.discount_application && d.discount_application.title) || 'Descuento';
          return '<span class="cart47__item-discount">▸ ' + title + '</span>';
        }).join('');
        var savingsTag = hasDiscount
          ? '<div class="cart47__item-savings">AHORRAS ' + fmt(lineSavings) + '</div>'
          : '';
        return ''
          + '<div class="cart47__item' + (hasDiscount ? ' is-discounted' : '') + '" data-item-key="' + it.key + '">'
          +   '<a class="cart47__item-img" href="' + it.url + '">'
          +     (img ? '<img src="' + img + '" alt="' + (it.product_title || '') + '" loading="lazy" width="64" height="80">' : '')
          +   '</a>'
          +   '<div class="cart47__item-info">'
          +     '<a class="cart47__item-title" href="' + it.url + '">' + (it.product_title || '') + '</a>'
          +     (variant ? '<div class="cart47__item-variant">' + variant + '</div>' : '')
          +     discountTags
          +     '<div class="cart47__item-qty">'
          +       '<button type="button" data-cart47-qty="-1" aria-label="Restar">−</button>'
          +       '<span>' + it.quantity + '</span>'
          +       '<button type="button" data-cart47-qty="1" aria-label="Sumar">+</button>'
          +       '<button type="button" class="cart47__item-remove" data-cart47-remove>Quitar</button>'
          +     '</div>'
          +   '</div>'
          +   '<div class="cart47__item-prices">'
          +     priceHtml
          +     savingsTag
          +   '</div>'
          + '</div>';
      }).join('');

      try { pintarFold(cart); } catch (e) {}

      /* Re-filtra upsells (items recién agregados/quitados pueden cambiar la lista) */
      try { if (typeof refreshUpsells === 'function') refreshUpsells(); } catch (e) {}

      /* Colapsa "Completa tu look" EN CUANTO hay productos en la bolsa · la prioridad
         es lo que el cliente va a pagar (sus productos + subtotal + checkout), NO el upsell.
         Solo se abre solo cuando la bolsa está vacía. Si el usuario lo toggleó manual
         (dataset.userToggled === '1'), respetamos su elección. */
      try {
        var ups = root.querySelector('[data-cart47-upsell]');
        if (ups && ups.dataset.userToggled !== '1') {
          var t = ups.querySelector('[data-cart47-upsell-toggle]');
          if ((cart.item_count || 0) >= 1) {
            ups.classList.add('is-collapsed');
            if (t) t.setAttribute('aria-expanded', 'false');
          } else {
            ups.classList.remove('is-collapsed');
            if (t) t.setAttribute('aria-expanded', 'true');
          }
        }
      } catch (e) {}
    }

    /* === CONTADOR + PLEGADO DEL DETALLE ===
       El chip solo aparece con productos dentro: con la bolsa vacía sobra. */
    function pintarFold(cart) {
      var n = cart.item_count || 0;
      var cEl = root.querySelector('[data-cart47-count]');
      if (cEl) { cEl.textContent = n; cEl.hidden = n === 0; }
      var fold = root.querySelector('[data-cart47-fold]');
      if (!fold) return;
      fold.hidden = n === 0;
      var nEl = root.querySelector('[data-cart47-fold-n]');
      var wEl = root.querySelector('[data-cart47-fold-w]');
      if (nEl) nEl.textContent = n;
      if (wEl) wEl.textContent = n === 1 ? 'producto' : 'productos';
    }
    (function initFold() {
      var fold = root.querySelector('[data-cart47-fold]');
      if (!fold) return;
      fold.addEventListener('click', function () {
        var abierto = fold.getAttribute('aria-expanded') !== 'false';
        fold.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        if (body) body.hidden = abierto;
        var t = root.querySelector('[data-cart47-fold-txt]');
        if (t) t.textContent = abierto ? 'Ver detalle' : 'Ocultar detalle';
      });
    })();

    /* === CUPÓN ===
       No se inventa un descuento en el front: el código viaja por /discount y
       Shopify lo aplica en el checkout, que es el único que sabe si es válido. */
    (function initCupon() {
      var f = root.querySelector('[data-cart47-cupon]');
      if (!f) return;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var campo = f.querySelector('input[name="codigo"]');
        var code = (campo && campo.value || '').trim();
        if (!code) { if (campo) campo.focus(); return; }
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
    })();

    (function initSum() {
      var t = root.querySelector('[data-cart47-sum-toggle]');
      var box = root.querySelector('[data-cart47-sum]');
      if (!t || !box) return;
      t.addEventListener('click', function () {
        var abierto = t.getAttribute('aria-expanded') === 'true';
        t.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        box.hidden = abierto;
      });
    })();

    /* === EL ÍCONO DE LA BOLSA ABRE EL DRAWER ===
       Era un <a href="/cart"> puro: tocarlo sacaba al cliente de donde estaba
       comprando y lo mandaba a otra página. Ahora abre la bolsa encima, como
       Amazon o Mercado Libre, y seguir comprando es cerrar el panel.

       Progressive enhancement: si el drawer no existe o el JS falla, el enlace
       sigue llevando a /cart. Se respeta cmd/ctrl/medio para abrir en pestaña
       nueva, y en /cart no se intercepta nada (ya estás ahí). */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest('[data-hdr47-cart-btn], [data-benv-bag], a.hdr47__cart, a.benv47__bag');
      if (!a) return;
      if (!document.querySelector('[data-cart47]')) return;      // sin drawer: que el link haga lo suyo
      if (/^\/cart\/?$/.test(window.location.pathname)) return;  // ya estás en el carrito
      e.preventDefault();
      try { window.dispatchEvent(new CustomEvent('cart47:open')); }
      catch (err) { window.location.href = '/cart'; }
    }, true);

    /* Listeners globales · permiten que código externo (cb47) abra y refresque el drawer */
    window.addEventListener('cart47:refresh', function () { refresh(); });
    window.addEventListener('cart47:open', function () {
      refresh().then(function () { open(); });
    });

    function refresh() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          if (window.CartCount47 && window.CartCount47.set) {
            window.CartCount47.set(cart.item_count || 0);
          }
          return cart;
        })
        .catch(function () {});
    }

    /* Close on scrim/close btn + Upsell collapsible toggle */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart47-close]')) { e.preventDefault(); close(); return; }
      var upsellToggle = e.target.closest('[data-cart47-upsell-toggle]');
      if (upsellToggle) {
        e.preventDefault();
        var upsellEl = upsellToggle.closest('[data-cart47-upsell]');
        if (!upsellEl) return;
        var nowCollapsed = !upsellEl.classList.contains('is-collapsed');
        upsellEl.classList.toggle('is-collapsed');
        upsellToggle.setAttribute('aria-expanded', nowCollapsed ? 'false' : 'true');
        /* Marca que el user tomó decisión manual · auto-collapse no la sobreescribe */
        upsellEl.dataset.userToggled = '1';
        return;
      }
    });

    /* Qty / remove */
    if (body) {
      body.addEventListener('click', function (e) {
        var item = e.target.closest('[data-item-key]');
        if (!item) return;
        var key = item.dataset.itemKey;
        var qtyBtn = e.target.closest('[data-cart47-qty]');
        if (qtyBtn) {
          e.preventDefault();
          var delta = parseInt(qtyBtn.dataset.cart47Qty, 10);
          var span = item.querySelector('.cart47__item-qty span');
          var current = span ? parseInt(span.textContent, 10) : 1;
          var newQty = Math.max(0, current + delta);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          }).then(refresh);
          return;
        }
        if (e.target.closest('[data-cart47-remove]')) {
          e.preventDefault();
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(refresh);
        }
      });
    }

    /* Esc cierra */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    /* API global */
    window.MiniCart47 = { open: open, close: close, refresh: refresh };

    /* === COUNTDOWN PROMO (DROP3 o lo que esté en data-cart47-promo-end) === */
    (function initPromoCountdown() {
      var promo = root.querySelector('[data-cart47-promo]');
      if (!promo) return;
      var endStr = root.getAttribute('data-cart47-promo-end');
      if (!endStr) { promo.hidden = true; return; }
      var endMs = Date.parse(endStr);
      if (isNaN(endMs)) { promo.hidden = true; return; }
      /* Un contador de 127 días no urge: aburre y resta credibilidad.
         Solo se muestra cuando de verdad queda poco. */
      var URGE_MS = 3 * 86400 * 1000;
      if (endMs - Date.now() > URGE_MS) { promo.hidden = true; return; }
      var labelText = root.getAttribute('data-cart47-promo-label');
      if (labelText) {
        var lblEl = promo.querySelector('[data-cart47-promo-label]');
        if (lblEl) lblEl.textContent = labelText;
      }
      var timeEl = promo.querySelector('[data-cart47-promo-time]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var rem = endMs - Date.now();
        if (rem <= 0) { promo.hidden = true; return false; }
        promo.hidden = false;
        var totalSec = Math.floor(rem / 1000);
        var d = Math.floor(totalSec / 86400);
        var h = Math.floor((totalSec % 86400) / 3600);
        var m = Math.floor((totalSec % 3600) / 60);
        var s = totalSec % 60;
        var out = d > 0
          ? d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s)
          : pad(h) + ':' + pad(m) + ':' + pad(s);
        if (timeEl && timeEl.textContent !== out) timeEl.textContent = out;
        return true;
      }
      if (tick()) setInterval(tick, 1000);
    })();

    /* === UPSELLS · filtra fuera del carrito · agrega inline === */
    var upsellWrap = root.querySelector('[data-cart47-upsell]');
    var upsellScroll = root.querySelector('[data-cart47-upsell-scroll]');
    var UPSELL_MAX = 3;
    function refreshUpsells() {
      if (!upsellWrap || !upsellScroll) return;
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ownedHandles = {};
          (cart.items || []).forEach(function (it) { if (it.handle) ownedHandles[it.handle] = true; });
          var cards = upsellScroll.querySelectorAll('[data-cart47-up-card]');
          var shown = 0;
          cards.forEach(function (card) {
            var h = card.getAttribute('data-handle');
            if (ownedHandles[h] || shown >= UPSELL_MAX) { card.hidden = true; return; }
            card.hidden = false;
            shown += 1;
          });
          upsellWrap.hidden = shown === 0;
        })
        .catch(function () { /* si falla, deja visible los primeros 3 */
          var cards = upsellScroll.querySelectorAll('[data-cart47-up-card]');
          cards.forEach(function (c, i) { c.hidden = i >= UPSELL_MAX; });
          upsellWrap.hidden = cards.length === 0;
        });
    }
    /* Handler de "+ Agregar" upsell */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart47-up-add]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var card = btn.closest('[data-cart47-up-card]');
      if (!card) return;
      var isDefaultOnly = card.getAttribute('data-default-only') === '1';
      var vid = parseInt(card.getAttribute('data-variant-id'), 10);
      if (!isDefaultOnly) {
        /* Producto con variantes · mejor que el user elija talla/color en PDP */
        var url = card.getAttribute('data-url');
        if (url) window.location.href = url;
        return;
      }
      var prev = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 }),
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok; })
        .then(function (ok) {
          if (ok) {
            btn.classList.add('is-success');
            btn.innerHTML = '<span aria-hidden="true">✓</span> Agregado';
            if (window.CartCount47 && window.CartCount47.fetch) window.CartCount47.fetch();
            refresh();
            setTimeout(function () {
              btn.classList.remove('is-success');
              btn.innerHTML = prev;
              btn.disabled = false;
            }, 1400);
          } else {
            btn.classList.add('is-error');
            btn.innerHTML = '✗ Error';
            setTimeout(function () {
              btn.classList.remove('is-error');
              btn.innerHTML = prev;
              btn.disabled = false;
            }, 1600);
          }
        })
        .catch(function () {
          btn.classList.add('is-error');
          btn.innerHTML = '✗ Error';
          setTimeout(function () {
            btn.classList.remove('is-error');
            btn.innerHTML = prev;
            btn.disabled = false;
          }, 1600);
        });
    });
    /* Refresca upsells al refrescar carrito */
    window.addEventListener('cart47:refresh', refreshUpsells);
    refreshUpsells();

    refresh();
  }

  /* "+ bolsa": agrega y abre el mini-cart sin redirigir */
  function initAddToMini() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-mini]');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('[data-card-buy]');
      var variantId = btn.dataset.variantId || (wrap && wrap.dataset.selectedVariant);
      var errEl = wrap && wrap.querySelector('[data-buy-error]');

      if (!variantId) {
        if (wrap) {
          wrap.classList.add('needs-size');
          var toggleBtn = wrap.querySelector('[data-size-toggle]');
          var sizesWrap = wrap.querySelector('[data-sizes-wrap]');
          if (toggleBtn && sizesWrap && sizesWrap.hidden) {
            sizesWrap.hidden = false;
            toggleBtn.setAttribute('aria-expanded', 'true');
            toggleBtn.classList.add('is-discovered');
          }
        }
        if (errEl) errEl.textContent = 'Elige una talla';
        return;
      }

      btn.disabled = true;
      btn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'Error'); });
          return r.json();
        })
        .then(function () {
          if (window.MiniCart47) {
            return window.MiniCart47.refresh().then(window.MiniCart47.open);
          }
        })
        .catch(function (err) {
          if (errEl) errEl.textContent = (err && err.message) || 'No se pudo agregar';
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    }, false);
  }

  /* ============ RULETA CONQUISTAR · email gate + spin ============ */
  function initRuleta() {
    var roots = document.querySelectorAll('[data-ruleta47]');
    if (!roots.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    roots.forEach(function (root) {
      var prizesData = root.querySelector('[data-prizes]');
      var prizes = [];
      try { prizes = JSON.parse(prizesData.textContent || '[]'); } catch (e) {}
      if (!prizes.length) return;

      var wheel = root.querySelector('[data-wheel]');
      var spinBtn = root.querySelector('[data-spin]');
      var formWrap = root.querySelector('[data-form-wrap]');
      var readyEl = root.querySelector('[data-ready]');
      var resultEl = root.querySelector('[data-result]');
      var resultTitle = root.querySelector('[data-result-title]');
      var resultDesc = root.querySelector('[data-result-desc]');
      var resultCodeWrap = root.querySelector('[data-result-code-wrap]');
      var resultCode = root.querySelector('[data-result-code]');
      var copyBtn = root.querySelector('[data-copy-code]');
      var claim = root.querySelector('[data-claim]');
      var form = root.querySelector('[data-form]');
      var emailInput = root.querySelector('[data-email]');

      var lsKey = 'ruleta47x';
      var n = prizes.length;
      var stepDeg = 360 / n;
      var currentRotation = 0;
      var hasSpun = false;

      try {
        var saved = JSON.parse(localStorage.getItem(lsKey) || 'null');
        if (saved && saved.spun) {
          showSavedResult(saved);
          return;
        }
      } catch (e) {}

      /* Form submit → unlock spin */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = (emailInput && emailInput.value || '').trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            emailInput.focus();
            return;
          }
          try {
            localStorage.setItem(lsKey + '.email', email);
          } catch (err) {}
          formWrap.hidden = true;
          if (readyEl) readyEl.hidden = false;
          if (spinBtn) {
            spinBtn.disabled = false;
            spinBtn.setAttribute('aria-disabled', 'false');
            spinBtn.classList.add('is-active');
          }
        });
      }

      /* Spin */
      if (spinBtn) {
        spinBtn.addEventListener('click', function () {
          if (hasSpun) return;
          hasSpun = true;
          spinBtn.disabled = true;
          spinBtn.classList.remove('is-active');

          /* Weighted pick */
          var totalW = prizes.reduce(function (s, p) { return s + (p.weight || 1); }, 0);
          var roll = Math.random() * totalW;
          var cum = 0;
          var pickedIdx = 0;
          for (var i = 0; i < prizes.length; i++) {
            cum += (prizes[i].weight || 1);
            if (roll < cum) { pickedIdx = i; break; }
          }
          var prize = prizes[pickedIdx];

          /* Target rotation: pointer at top (0°), slice center at pickedIdx*step + step/2.
             Need wheel.rotation = -(sliceCenter) + 5 full turns (clockwise, so positive). */
          var sliceCenter = pickedIdx * stepDeg + stepDeg / 2;
          var target = 360 * 5 + (360 - sliceCenter);
          currentRotation = target;

          if (reduced) {
            wheel.style.transition = 'none';
            wheel.style.transform = 'rotate(' + target + 'deg)';
            setTimeout(function () { showResult(prize); }, 50);
          } else {
            wheel.style.transition = 'transform 4.2s cubic-bezier(.22,.85,.22,1)';
            requestAnimationFrame(function () {
              wheel.style.transform = 'rotate(' + target + 'deg)';
            });
            setTimeout(function () { showResult(prize); }, 4300);
          }

          /* Persist */
          var saved = { spun: true, prize: prize, ts: Date.now() };
          try { localStorage.setItem(lsKey, JSON.stringify(saved)); } catch (e) {}
        });
      }

      function showResult(prize) {
        if (readyEl) readyEl.hidden = true;
        if (resultEl) resultEl.hidden = false;
        if (resultTitle) resultTitle.textContent = prize.name || '—';
        if (resultDesc) resultDesc.textContent = prize.desc || '';
        if (prize.type === 'digital' && prize.code) {
          if (resultCodeWrap) resultCodeWrap.hidden = false;
          if (resultCode) resultCode.textContent = prize.code;
          if (claim) {
            claim.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(prize.url || '/collections/all');
            claim.textContent = 'USAR ' + prize.code + ' →';
          }
        } else {
          if (resultCodeWrap) resultCodeWrap.hidden = true;
          if (claim) {
            claim.href = prize.url || '/pages/contact';
            claim.textContent = 'CONTACTAR PARA RECLAMAR →';
          }
        }
      }

      function showSavedResult(saved) {
        if (formWrap) formWrap.hidden = true;
        if (readyEl) readyEl.hidden = true;
        if (spinBtn) {
          spinBtn.disabled = true;
          spinBtn.textContent = 'YA GIRASTE';
        }
        showResult(saved.prize || {});
      }

      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = resultCode && resultCode.textContent || '';
          if (!code) return;
          try {
            navigator.clipboard.writeText(code);
            copyBtn.textContent = 'COPIADO';
            setTimeout(function () { copyBtn.textContent = 'COPIAR'; }, 1600);
          } catch (e) {}
        });
      }
    });
  }

  /* "← VOLVER" inteligente */
  function initBackLink() {
    document.querySelectorAll('[data-back47]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
    });
  }

  /* ============ CONTADOR PRO · count-up + ranking bar + carrusel ============ */
  function initContadorPro() {
    var roots = document.querySelectorAll('[data-contador-pro]');
    if (!roots.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    roots.forEach(function (root) {
      var counterEl = root.querySelector('[data-counter]');
      var counterTarget = counterEl ? parseInt(counterEl.dataset.target, 10) || 0 : 0;
      var rankBar = root.querySelector('[data-ranking-bar]');
      var rankPct = rankBar ? parseFloat(rankBar.dataset.targetPct) || 0 : 0;
      var refs = Array.prototype.slice.call(root.querySelectorAll('[data-ref]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
      var carousel = root.querySelector('[data-carousel]');
      var speedSec = carousel ? (parseFloat(carousel.dataset.speed) || 4) : 4;

      var refIdx = 0;
      var refTimer = null;
      var carouselStarted = false;

      function fmtMX(n) {
        try { return n.toLocaleString('es-MX'); } catch (e) { return String(n); }
      }
      function countUp() {
        if (!counterEl || counterTarget <= 0) return;
        if (reduced) { counterEl.textContent = fmtMX(counterTarget); return; }
        var start = performance.now();
        var dur = 1800;
        function tick(now) {
          var t = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - t, 3);
          counterEl.textContent = fmtMX(Math.floor(eased * counterTarget));
          if (t < 1) requestAnimationFrame(tick);
          else counterEl.textContent = fmtMX(counterTarget);
        }
        requestAnimationFrame(tick);
      }
      function fillBar() {
        if (!rankBar) return;
        if (reduced) { rankBar.style.transition = 'none'; rankBar.style.width = rankPct + '%'; return; }
        /* dejar un frame para que la transición se enganche */
        requestAnimationFrame(function () {
          rankBar.style.width = rankPct + '%';
        });
      }
      var carouselTickMs = speedSec * 1000;
      function carouselTickFn() {
        refs[refIdx].classList.remove('is-active');
        if (dots[refIdx]) dots[refIdx].classList.remove('is-on');
        refIdx = (refIdx + 1) % refs.length;
        refs[refIdx].classList.add('is-active');
        if (dots[refIdx]) dots[refIdx].classList.add('is-on');
      }
      function carouselStart() {
        if (refTimer || refs.length < 2 || reduced) return;
        refTimer = setInterval(carouselTickFn, carouselTickMs);
      }
      function carouselStop() {
        if (refTimer) { clearInterval(refTimer); refTimer = null; }
      }
      function startCarousel() {
        if (carouselStarted) return;
        carouselStarted = true;
        if (!refs.length) return;
        refs.forEach(function (r, i) { r.classList.toggle('is-active', i === 0); });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === 0); });
        if (refs.length < 2 || reduced) return;
        /* Móvil/táctil: loop de notificaciones "atleta desbloqueó..." mucho más lento */
        var isMobileTick = window.matchMedia('(max-width:760px)').matches || (navigator.maxTouchPoints || 0) > 0;
        carouselTickMs = isMobileTick ? Math.max(speedSec * 1000, 15000) : speedSec * 1000;
        carouselStart();
      }

      function activate() {
        countUp();
        fillBar();
        startCarousel();
      }

      if ('IntersectionObserver' in window) {
        /* IO doble: 1) activar al entrar (countUp + bar + start carousel)
                     2) pausar/reanudar setInterval cuando entra/sale del viewport */
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { activate(); io.unobserve(root); }
          });
        }, { rootMargin: '0px 0px -8% 0px' });
        io.observe(root);
        var ioPause = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!carouselStarted) return;
            if (e.isIntersecting) carouselStart(); else carouselStop();
          });
        }, { threshold: 0, rootMargin: '50px 0px' });
        ioPause.observe(root);
      } else {
        activate();
      }
    });
  }

  /* ============ QUICK BUY · COMPRAR AHORA directo al checkout ============
     Delegado en document: funciona en cualquier card (slider hero, lista47, etc.).
     - Single variant: POST /cart/add.js + window.location='/checkout'
     - Multi variant: tap en talla → seleccionar → COMPRAR AHORA
  */
  function initQuickBuy() {
    document.addEventListener('click', function (e) {
      /* Toggle del menú de tallas */
      var sizeToggle = e.target.closest('[data-size-toggle]');
      if (sizeToggle) {
        e.preventDefault();
        var wrap = sizeToggle.closest('[data-card-buy]');
        if (!wrap) return;
        var sizesWrap = wrap.querySelector('[data-sizes-wrap]');
        if (!sizesWrap) return;
        var isOpen = sizeToggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          sizesWrap.hidden = true;
          sizeToggle.setAttribute('aria-expanded', 'false');
        } else {
          sizesWrap.hidden = false;
          sizeToggle.setAttribute('aria-expanded', 'true');
          /* Quitar parpadeo una vez que el usuario ya supo dónde está */
          sizeToggle.classList.add('is-discovered');
        }
        return;
      }

      var sizePill = e.target.closest('[data-size-pill]');
      if (sizePill) {
        e.preventDefault();
        if (sizePill.hasAttribute('disabled')) return;
        var wrap = sizePill.closest('[data-card-buy]');
        if (!wrap) return;
        wrap.querySelectorAll('[data-size-pill]').forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        sizePill.classList.add('is-active');
        sizePill.setAttribute('aria-checked', 'true');
        wrap.dataset.selectedVariant = sizePill.dataset.variantId;
        var errEl = wrap.querySelector('[data-buy-error]');
        if (errEl) errEl.textContent = '';
        wrap.classList.remove('needs-size');
        return;
      }

      var buyBtn = e.target.closest('[data-buy-now]');
      if (!buyBtn) return;
      e.preventDefault();

      var wrap = buyBtn.closest('[data-card-buy]');
      var variantId = buyBtn.dataset.variantId || (wrap && wrap.dataset.selectedVariant);
      var errEl = wrap && wrap.querySelector('[data-buy-error]');

      if (!variantId) {
        if (wrap) {
          wrap.classList.add('needs-size');
          /* Si está colapsado, ábrelo automáticamente */
          var toggleBtn = wrap.querySelector('[data-size-toggle]');
          var sizesWrap = wrap.querySelector('[data-sizes-wrap]');
          if (toggleBtn && sizesWrap && sizesWrap.hidden) {
            sizesWrap.hidden = false;
            toggleBtn.setAttribute('aria-expanded', 'true');
            toggleBtn.classList.add('is-discovered');
          }
        }
        if (errEl) errEl.textContent = 'Elige una talla';
        return;
      }

      buyBtn.disabled = true;
      var labelEl = buyBtn.querySelector('.card-buy-label');
      var prevLabel = labelEl ? labelEl.textContent : 'COMPRAR AHORA';
      if (labelEl) labelEl.textContent = 'PROCESANDO…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (r) {
          if (r.ok) {
            window.location.href = '/checkout';
            return;
          }
          return r.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || 'No se pudo agregar al carrito');
          });
        })
        .catch(function (err) {
          if (labelEl) labelEl.textContent = prevLabel;
          buyBtn.disabled = false;
          if (errEl) errEl.textContent = (err && err.message) || 'Intenta de nuevo';
        });
    }, false);
  }

  /* ============ HERO LAB · SISTEMA 47X · ONLINE ============ */
  function initHero() {
    var hero = document.querySelector('[data-hero-lab]');
    if (!hero) return;

    initHeroLoader(hero);
    initHeroSlider(hero);
    initHeroCardTilt(hero);
    initHeroPressStart(hero);
    initHeroVideoMotion(hero);
    initHeroReveals(hero);

    /* Coordinador de pausa offscreen + lazy-init de partículas/matrix tras idle */
    var particles = null;
    var matrix = null;
    var video = hero.querySelector('.hero-lab__video');
    var schedule = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };

    function ensureParticles() {
      if (particles) return;
      var canvasEl = hero.querySelector('[data-particles]');
      if (!canvasEl) return;
      particles = createHeroParticles(hero, canvasEl);
    }
    function ensureMatrix() {
      if (matrix) return;
      var canvasEl = hero.querySelector('[data-matrix]');
      if (!canvasEl) return;
      matrix = createHeroMatrix(hero, canvasEl);
    }

    function resume() {
      hero.classList.remove('is-offscreen');
      if (video) { try { video.play(); } catch (e) {} }
      if (!particles) schedule(function () { ensureParticles(); if (particles) particles.start(); });
      else particles.start();
      if (!matrix) schedule(function () { ensureMatrix(); if (matrix) matrix.start(); });
      else matrix.start();
    }
    function pause() {
      hero.classList.add('is-offscreen');
      if (video) { try { video.pause(); } catch (e) {} }
      if (particles) particles.stop();
      if (matrix) matrix.stop();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) resume();
          else pause();
        }
      }, { threshold: 0, rootMargin: '120px 0px' });
      io.observe(hero);
    } else {
      /* Fallback: arranca y se queda */
      resume();
    }
  }

  function initHeroLoader(hero) {
    var loader = hero.querySelector('[data-loader]');
    if (!loader) return;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var isMobile = window.matchMedia('(max-width:760px)').matches || (navigator.maxTouchPoints || 0) > 0;
    /* En móvil/táctil o reduced-motion: loader nunca aparece (cero animaciones costosas) */
    if (reduced || isMobile) { loader.style.display = 'none'; return; }
    try {
      if (sessionStorage.getItem('hero47Booted')) {
        loader.style.display = 'none';
        return;
      }
    } catch (e) {}

    /* HARD SAFETY · pase lo que pase, esconde el loader a los 4s.
       Evita que un rAF que no corre (tab inactivo) o un error JS
       lo deje atascado para siempre. */
    var safetyHide = setTimeout(function () {
      loader.classList.add('hero-lab__loader--hide');
      try { sessionStorage.setItem('hero47Booted', '1'); } catch (e) {}
    }, 4000);

    var bar = loader.querySelector('.hero-lab__loader-bar i');
    var pct = loader.querySelector('[data-loader-pct]');
    var inner = loader.querySelector('.hero-lab__loader-inner');
    var start = performance.now();
    var duration = 1400;
    var glitched = false;

    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var n = Math.round(eased * 100);
      if (bar) bar.style.width = n + '%';
      if (pct) pct.textContent = n + '%';
      if (!glitched && t > 0.42 && t < 0.58 && inner) {
        glitched = true;
        inner.classList.add('hero-lab__loader--glitch');
        setTimeout(function () { inner.classList.remove('hero-lab__loader--glitch'); }, 220);
      }
      if (t < 1) requestAnimationFrame(tick);
      else setTimeout(function () {
        clearTimeout(safetyHide);
        loader.classList.add('hero-lab__loader--hide');
        try { sessionStorage.setItem('hero47Booted', '1'); } catch (e) {}
      }, 260);
    }
    requestAnimationFrame(tick);
  }

  /* Factoría de partículas — start/stop, sprite pre-renderizado, sin shadowBlur por frame */
  function createHeroParticles(hero, canvas) {
    /* Gate explícito móvil/táctil: partículas jamás corren en cel */
    if (window.matchMedia('(max-width:760px)').matches || (navigator.maxTouchPoints || 0) > 0) {
      return { start: function () {}, stop: function () {} };
    }
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
      return { start: function () {}, stop: function () {} };
    }
    /* .lite (móvil / equipo débil / save-data): partículas COMPLETAMENTE apagadas
       para no calentar el dispositivo */
    if (window.__tier47 && window.__tier47.isLite) {
      return { start: function () {}, stop: function () {} };
    }

    var ctx = canvas.getContext('2d', { alpha: true });
    var isLite = window.__tier47 && window.__tier47.isLite;
    var isMobile = window.innerWidth < 760;
    var COUNT = isLite ? 24 : (isMobile ? 30 : 60);
    var dpr = isLite ? 1 : Math.min(window.devicePixelRatio || 1, 1.5);
    /* Throttle FPS: 30fps en .lite, 60 en desktop */
    var FRAME_BUDGET = isLite ? (1000 / 28) : (1000 / 60);
    var lastFrame = 0;
    var w = 0, h = 0;
    var particles = [];
    var sprite = null;
    var spriteSize = 0;
    var rafId = 0;
    var running = false;
    var inited = false;

    function buildSprite() {
      spriteSize = Math.round(16 * dpr);
      sprite = document.createElement('canvas');
      sprite.width = sprite.height = spriteSize;
      var sc = sprite.getContext('2d');
      var c = spriteSize / 2;
      var grd = sc.createRadialGradient(c, c, 0, c, c, c);
      grd.addColorStop(0,    getAccentRgba(1));
      grd.addColorStop(0.35, getAccentRgba(0.55));
      grd.addColorStop(1,    getAccentRgba(0));
      sc.fillStyle = grd;
      sc.fillRect(0, 0, spriteSize, spriteSize);
    }
    function resize() {
      var r = hero.getBoundingClientRect();
      w = canvas.width = Math.max(1, Math.floor(r.width * dpr));
      h = canvas.height = Math.max(1, Math.floor(r.height * dpr));
      canvas.style.width = r.width + 'px';
      canvas.style.height = r.height + 'px';
    }
    function spawn() {
      particles = [];
      for (var i = 0; i < COUNT; i++) {
        particles.push({
          x: Math.random() * w,
          y: Math.random() * h,
          vx: (Math.random() - 0.5) * 0.4 * dpr,
          vy: (Math.random() - 0.5) * 0.4 * dpr,
          s: 0.6 + Math.random() * 0.9,    /* sprite scale, sin dpr aquí */
          o: 0.25 + Math.random() * 0.5
        });
      }
    }
    function step(now) {
      if (!running) return;
      /* FPS throttle: solo dibuja si pasó el budget */
      if (now - lastFrame < FRAME_BUDGET) {
        rafId = requestAnimationFrame(step);
        return;
      }
      lastFrame = now;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.vx; p.y += p.vy;
        if (p.x < -spriteSize) p.x = w + spriteSize;
        else if (p.x > w + spriteSize) p.x = -spriteSize;
        if (p.y < -spriteSize) p.y = h + spriteSize;
        else if (p.y > h + spriteSize) p.y = -spriteSize;
        var sz = spriteSize * p.s;
        ctx.globalAlpha = p.o;
        ctx.drawImage(sprite, p.x - sz / 2, p.y - sz / 2, sz, sz);
      }
      ctx.globalAlpha = 1;
      rafId = requestAnimationFrame(step);
    }

    var resizeTimer = 0;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { resize(); spawn(); }, 200);
    }

    return {
      start: function () {
        if (running) return;
        if (!inited) {
          buildSprite();
          resize();
          spawn();
          window.addEventListener('resize', onResize);
          inited = true;
        }
        running = true;
        rafId = requestAnimationFrame(step);
      },
      stop: function () {
        running = false;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = 0;
      }
    };
  }

  function initHeroSlider(hero) {
    var slider = hero.querySelector('[data-slider]');
    if (!slider) return;
    var track = slider.querySelector('[data-track]');
    var prev = hero.querySelector('[data-slider-prev]');
    var next = hero.querySelector('[data-slider-next]');
    var bulletsEl = slider.querySelector('[data-bullets]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;

    if (bulletsEl) {
      var html = '';
      for (var i = 0; i < cards.length; i++) {
        html += '<i data-bullet="' + i + '"' + (i === 0 ? ' class="is-active"' : '') + '></i>';
      }
      bulletsEl.innerHTML = html;
    }

    function activeIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var cc = cards[i].offsetLeft + cards[i].offsetWidth / 2;
        var d = Math.abs(cc - center);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function updateActive() {
      var idx = activeIndex();
      if (bulletsEl) {
        var bs = bulletsEl.querySelectorAll('i');
        for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('is-active', i === idx);
      }
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActive);
    }, { passive: true });

    function scrollByCard(dir) {
      var w = cards[0].offsetWidth + 18;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    /* drag + inercia + snap */
    var isDown = false;
    var startX = 0, scrollStart = 0, lastX = 0, lastT = 0, velocity = 0, dragMoved = false;

    function dragStart(x) {
      isDown = true; dragMoved = false;
      startX = lastX = x;
      scrollStart = track.scrollLeft;
      lastT = performance.now();
      velocity = 0;
      track.classList.add('is-dragging');
    }
    function dragMove(x) {
      if (!isDown) return;
      var dx = x - startX;
      if (Math.abs(dx) > 4) dragMoved = true;
      track.scrollLeft = scrollStart - dx;
      var now = performance.now();
      var dt = now - lastT;
      if (dt > 0) velocity = (x - lastX) / dt;
      lastX = x; lastT = now;
    }
    function snapNearest() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = cards[0], bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var cc = cards[i].offsetLeft + cards[i].offsetWidth / 2;
        var d = Math.abs(cc - center);
        if (d < bestDist) { bestDist = d; best = cards[i]; }
      }
      var targetLeft = best.offsetLeft - (track.clientWidth - best.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    }
    function dragEnd() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      // resetear tilt residual
      for (var i = 0; i < cards.length; i++) cards[i].style.transform = '';
      var proj = velocity * 220;
      if (Math.abs(proj) > 10) {
        track.scrollBy({ left: -proj, behavior: 'smooth' });
        setTimeout(snapNearest, 260);
      } else {
        snapNearest();
      }
    }

    track.addEventListener('mousedown', function (e) { dragStart(e.clientX); });
    window.addEventListener('mousemove', function (e) { dragMove(e.clientX); });
    window.addEventListener('mouseup', dragEnd);
    track.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    track.addEventListener('touchstart', function (e) { dragStart(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchmove',  function (e) { dragMove(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchend', dragEnd);

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { scrollByCard(1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { scrollByCard(-1); e.preventDefault(); }
    });

    updateActive();
  }

  function initHeroCardTilt(hero) {
    /* Tilt 3D — throttle por rAF, solo en pointer fino y NO en .lite */
    if (window.__tier47 && window.__tier47.isLite) return;
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var cards = hero.querySelectorAll('.hero-lab__card');
    cards.forEach(function (card) {
      var queued = false, lastX = 0, lastY = 0;
      function apply() {
        queued = false;
        var track = card.closest('.hero-lab__track');
        if (track && track.classList.contains('is-dragging')) return;
        var r = card.getBoundingClientRect();
        var px = (lastX - r.left) / r.width - 0.5;
        var py = (lastY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (px * 7) + 'deg) rotateX(' + (-py * 7) + 'deg) translateZ(0)';
      }
      card.addEventListener('mousemove', function (e) {
        lastX = e.clientX; lastY = e.clientY;
        if (!queued) { queued = true; requestAnimationFrame(apply); }
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(900px) rotateY(0) rotateX(0)';
      });
    });
  }

  function initHeroPressStart(hero) {
    var btn = hero.querySelector('[data-press-start]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      // PRESS START → /pages/atletas (plataforma gamificada de retos).
      // Si el atleta no está logueado, /pages/atletas dispara su propio gate
      // que redirige a /account/login?return_url=/pages/atletas.
      window.location.href = '/pages/atletas';
    });
  }

  function initHeroVideoMotion(hero) {
    var video = hero.querySelector('.hero-lab__video');
    if (!video) return;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var isMobile = window.innerWidth < 760;
    if (reduced || isMobile) {
      try { video.pause(); } catch (e) {}
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
    }
  }

  function initHeroReveals(hero) {
    /* Reveals con IntersectionObserver — más liviano que ScrollTrigger.
       Las animaciones del hero `[data-hero]` siguen usando initGsap global. */
    var els = hero.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-revealed');
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ============ SLOT SISTEMA ROTO · sorteo de packs-premio ============
     Casino-style reel · pick ponderado · persistencia por usuario
     · checkout directo con variant_id real · talla + add-to-cart */
  function initSlot47() {
    var roots = document.querySelectorAll('[data-slot47]');
    if (!roots.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    roots.forEach(function (root) {
      var prizesEl = root.querySelector('[data-prizes]');
      var prizes = [];
      try { prizes = JSON.parse(prizesEl.textContent || '[]'); } catch (e) {}
      if (!prizes.length) return;

      /* 3 reels · cada uno tiene su propio strip */
      var strips = Array.prototype.slice.call(root.querySelectorAll('[data-strip]'));
      var leverBtn = root.querySelector('[data-lever]');
      var spinBtn = root.querySelector('[data-spin]');
      var spinLabel = root.querySelector('[data-spin-label]');
      var spinHint = root.querySelector('[data-spin-hint]');
      var resultEl = root.querySelector('[data-result]');
      var resultImg = root.querySelector('[data-result-img]');
      var resultName = root.querySelector('[data-result-name]');
      var resultPrice = root.querySelector('[data-result-price]');
      var resultCompare = root.querySelector('[data-result-compare]');
      var resultSave = root.querySelector('[data-result-save]');
      var sizesWrap = root.querySelector('[data-sizes-wrap]');
      var sizesBox = root.querySelector('[data-sizes]');
      var sizeError = root.querySelector('[data-size-error]');
      /* Dropdown de tallas (al lado del nombre) */
      var sizeDdTrigger = root.querySelector('[data-size-dd-trigger]');
      var sizeDdPanel = root.querySelector('[data-size-dd-panel]');
      var sizeDdValue = root.querySelector('[data-size-dd-value]');
      /* Color picker (recuadro separado) */
      var colorPickerWrap = root.querySelector('[data-color-picker]');
      var colorPills = root.querySelector('[data-color-pills]');
      var colorSelectedLabel = root.querySelector('[data-color-picker-selected]');
      /* Estado de selección de variantes */
      var selectedColor = null;
      var selectedSize = null;
      var currentPrize = null;
      function openSizeDd() {
        if (!sizeDdPanel || !sizeDdTrigger) return;
        sizeDdPanel.hidden = false;
        sizeDdTrigger.setAttribute('aria-expanded', 'true');
      }
      function closeSizeDd() {
        if (!sizeDdPanel || !sizeDdTrigger) return;
        sizeDdPanel.hidden = true;
        sizeDdTrigger.setAttribute('aria-expanded', 'false');
      }
      if (sizeDdTrigger) {
        sizeDdTrigger.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (sizeDdPanel.hidden) openSizeDd(); else closeSizeDd();
        });
        /* Click fuera cierra · solo cuando está abierto */
        document.addEventListener('click', function (e) {
          if (sizeDdPanel.hidden) return;
          if (e.target.closest('[data-size-dd]')) return;
          closeSizeDd();
        });
        /* Escape cierra */
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !sizeDdPanel.hidden) closeSizeDd();
        });
      }
      var buyBtn = root.querySelector('[data-buy-now]');
      var addBtn = root.querySelector('[data-add-cart]');
      var rerrollBtn = root.querySelector('[data-rerroll]');

      var lsKey = root.dataset.storageKey || '47x_slot_prize';
      var spinMs = parseInt(root.dataset.spinMs, 10) || 3600;
      var allowRerroll = root.dataset.allowRerroll === 'true';
      var freeShipCode = (root.dataset.freeShipCode || '').trim();

      var itemH = 0;
      function measureItem() {
        var firstItem = root.querySelector('.slot47__reel-item');
        if (firstItem) itemH = firstItem.getBoundingClientRect().height;
      }
      measureItem();
      window.addEventListener('resize', function () {
        measureItem();
        /* Re-aplica targetY guardado en cada strip */
        strips.forEach(function (s) {
          var ty = s.dataset.targetY;
          if (ty) {
            s.style.transition = 'none';
            s.style.transform = 'translate3d(0,' + ty + 'px,0)';
          }
        });
      }, { passive: true });

      var selectedPrize = null;
      var selectedVariantId = null;
      var isSpinning = false;

      /* === Restore prior prize · lock-in (es tuyo, no se repite) === */
      try {
        var saved = JSON.parse(localStorage.getItem(lsKey) || 'null');
        if (saved && saved.handle) {
          var match = null;
          for (var i = 0; i < prizes.length; i++) {
            if (prizes[i].handle === saved.handle) { match = prizes[i]; break; }
          }
          if (match) showResult(match, { skipAnim: true });
        }
      } catch (e) {}

      /* === Click handlers · botón principal y palanca === */
      function triggerSpin() {
        if (isSpinning) return;
        if (selectedPrize && !allowRerroll) return;
        spin();
      }
      if (spinBtn) spinBtn.addEventListener('click', triggerSpin);
      if (leverBtn) {
        leverBtn.addEventListener('click', function () {
          /* Animación de la palanca · activa is-pulling · luego revierte */
          if (isSpinning) return;
          root.classList.add('is-pulling');
          setTimeout(function () { root.classList.remove('is-pulling'); }, 480);
          triggerSpin();
        });
      }
      if (rerrollBtn) {
        rerrollBtn.addEventListener('click', function () {
          try { localStorage.removeItem(lsKey); } catch (e) {}
          selectedPrize = null;
          selectedVariantId = null;
          if (resultEl) resultEl.hidden = true;
          if (spinBtn) {
            spinBtn.disabled = false;
            if (spinLabel) spinLabel.textContent = root.dataset.spinLabelOrig || (spinLabel.textContent || 'ACTIVAR PROMO');
          }
        });
      }

      function pickWeightedIdx() {
        var totalW = 0;
        for (var i = 0; i < prizes.length; i++) totalW += (prizes[i].weight || 1);
        var roll = Math.random() * totalW;
        var cum = 0;
        for (var j = 0; j < prizes.length; j++) {
          cum += (prizes[j].weight || 1);
          if (roll < cum) return j;
        }
        return 0;
      }

      function moveStrip(stripEl, pickIdx, durationMs, landingRepeat) {
        var n = prizes.length;
        var targetIdx = landingRepeat * n + pickIdx;
        /* Para centrar la imagen ganadora en la línea central del reel,
           restamos la mitad de un slot de altura del reel */
        var reelEl = stripEl.closest('.slot47__reel');
        var reelH = reelEl ? reelEl.getBoundingClientRect().height : itemH;
        var centerOffset = (reelH - itemH) / 2;
        var targetY = -(targetIdx * itemH) + centerOffset;

        stripEl.style.transition = 'none';
        stripEl.style.transform = 'translate3d(0,0,0)';
        // force reflow
        void stripEl.offsetHeight;
        stripEl.style.transition = 'transform ' + durationMs + 'ms cubic-bezier(0.16, 1, 0.3, 1)';
        stripEl.style.transform = 'translate3d(0,' + targetY + 'px,0)';
        stripEl.dataset.targetY = targetY;
      }

      function spin() {
        var pickIdx = pickWeightedIdx();
        var prize = prizes[pickIdx];
        selectedPrize = prize;
        isSpinning = true;
        if (spinBtn) spinBtn.disabled = true;
        if (spinLabel) {
          root.dataset.spinLabelOrig = spinLabel.textContent;
          spinLabel.textContent = 'GIRANDO…';
        }
        root.classList.add('is-spinning');

        if (reduced) {
          /* Reduced motion · snap directo cero animación */
          strips.forEach(function (s, idx) { moveStrip(s, pickIdx, 0, 4); });
          setTimeout(function () {
            root.classList.remove('is-spinning');
            isSpinning = false;
            showResult(prize);
          }, 60);
          return;
        }

        measureItem();
        if (!itemH || !strips.length) {
          root.classList.remove('is-spinning');
          isSpinning = false;
          showResult(prize);
          return;
        }

        /* Stagger · cada reel para en momentos distintos para sensación tragamonedas
           Reel 0 para primero · 1 después · 2 al final */
        var stagger = [0, 350, 700];
        strips.forEach(function (s, idx) {
          var dur = spinMs + (stagger[idx] || 0);
          moveStrip(s, pickIdx, dur, 4 + idx);
        });

        var finalDelay = spinMs + 700 + 80;
        setTimeout(function () {
          root.classList.remove('is-spinning');
          /* BIG WIN flash al completar */
          root.classList.add('is-bigwin');
          setTimeout(function () { root.classList.remove('is-bigwin'); }, 1700);
          showResult(prize);
          isSpinning = false;
        }, finalDelay);
      }

      function fmtMx(cents) {
        var n = Math.round((cents || 0) / 100);
        try { return '$' + n.toLocaleString('es-MX'); } catch (e) { return '$' + n; }
      }

      function showResult(prize, opts) {
        opts = opts || {};
        selectedPrize = prize;
        selectedVariantId = null;
        try {
          localStorage.setItem(lsKey, JSON.stringify({ handle: prize.handle, ts: Date.now() }));
        } catch (e) {}

        /* Apunta los 3 strips directamente al item en modo skipAnim · sin transición */
        if (opts.skipAnim) {
          measureItem();
          if (itemH) {
            var pickIdx2 = 0;
            for (var k = 0; k < prizes.length; k++) {
              if (prizes[k].handle === prize.handle) { pickIdx2 = k; break; }
            }
            strips.forEach(function (s, idx) {
              var landingRepeat = 4 + idx;
              moveStrip(s, pickIdx2, 0, landingRepeat);
              /* Limpia transition para que quede instantáneo */
              s.style.transition = 'none';
            });
          }
          if (spinBtn) {
            spinBtn.disabled = true;
            if (spinLabel) spinLabel.textContent = '✓ PREMIO ASIGNADO';
          }
          if (spinHint) spinHint.textContent = 'Tu premio quedó bloqueado · elige talla y reclama';
        }

        if (resultImg) {
          resultImg.src = prize.image;
          resultImg.alt = prize.title;
        }
        if (resultName) resultName.textContent = prize.title;
        if (resultPrice) resultPrice.textContent = fmtMx(prize.price);
        if (resultCompare) {
          if (prize.compare_at && prize.compare_at > prize.price) {
            resultCompare.textContent = fmtMx(prize.compare_at);
            resultCompare.hidden = false;
            if (resultSave) {
              var save = prize.compare_at - prize.price;
              resultSave.textContent = 'AHORRAS ' + fmtMx(save);
              resultSave.hidden = false;
            }
          } else {
            resultCompare.hidden = true;
            if (resultSave) resultSave.hidden = true;
          }
        }
        renderSizes(prize);
        if (resultEl) resultEl.hidden = false;
        /* Scroll suave al resultado solo si fue spin · no en restore */
        if (!opts.skipAnim) {
          setTimeout(function () {
            try { resultEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
          }, 250);
        }
      }

      /* ===========================================================
         Render colores + tallas para el premio
         - Detecta si las variantes tienen opciones Color + Talla
         - Renderiza picker de colores (si > 1 color) en su recuadro
         - Renderiza dropdown de tallas (filtradas por color elegido)
         =========================================================== */
      var SWATCH_MAP = {
        'negro':'#0a0a0a','black':'#0a0a0a','jet':'#0a0a0a',
        'blanco':'#f5f5f5','white':'#f5f5f5','bone':'#ECE5D8','hueso':'#ECE5D8',
        'verde':'#39FF14','green':'#39FF14','militar':'#3b4a2a','olive':'#3b4a2a','olivo':'#3b4a2a',
        'rojo':'#dc2626','red':'#dc2626','vino':'#7c1a1a',
        'azul':'#1d4ed8','blue':'#1d4ed8','navy':'#0a1a3a','marino':'#0a1a3a',
        'gris':'#7a7a7a','gray':'#7a7a7a','grey':'#7a7a7a','plomo':'#5a5a5a',
        'cafe':'#5b3a1f','café':'#5b3a1f','brown':'#5b3a1f','marrón':'#5b3a1f','marron':'#5b3a1f',
        'beige':'#d6c7a8','arena':'#d6c7a8','tan':'#d2b48c','khaki':'#c3b091',
        'amarillo':'#fcd34d','yellow':'#fcd34d','dorado':'#d4af37','gold':'#d4af37',
        'rosa':'#ec4899','pink':'#ec4899','rosado':'#ec4899',
        'morado':'#7c3aed','purple':'#7c3aed','lila':'#a78bfa',
        'naranja':'#ea580c','orange':'#ea580c',
        'wash':'#5b5042','acid':'#c8c89f'
      };
      function colorToSwatch(name) {
        if (!name) return null;
        var key = String(name).toLowerCase().trim();
        if (SWATCH_MAP[key]) return SWATCH_MAP[key];
        /* búsqueda parcial: "wash militar" → "militar" → olive */
        var keys = Object.keys(SWATCH_MAP);
        for (var i = 0; i < keys.length; i++) {
          if (key.indexOf(keys[i]) !== -1) return SWATCH_MAP[keys[i]];
        }
        return null;
      }

      function detectOptionIdx(options) {
        var colorIdx = -1, sizeIdx = -1;
        for (var i = 0; i < options.length; i++) {
          var n = String(options[i] || '').toLowerCase();
          if (colorIdx === -1 && (n.indexOf('color') !== -1 || n === 'colour')) colorIdx = i;
          else if (sizeIdx === -1 && (n.indexOf('talla') !== -1 || n.indexOf('size') !== -1)) sizeIdx = i;
        }
        /* Heurística si no hay nombres claros */
        if (colorIdx === -1 && sizeIdx === -1) {
          if (options.length >= 2) { colorIdx = 0; sizeIdx = 1; }
          else if (options.length === 1) { sizeIdx = 0; }
        }
        return { color: colorIdx, size: sizeIdx };
      }

      function uniqueOptValues(variants, idx) {
        var seen = {};
        var out = [];
        variants.forEach(function (v) {
          var key = ['option1','option2','option3'][idx];
          var val = v[key];
          if (val && !seen[val]) { seen[val] = true; out.push(val); }
        });
        return out;
      }

      function renderSizes(prize) {
        currentPrize = prize;
        selectedColor = null;
        selectedSize = null;
        selectedVariantId = null;
        if (sizeError) sizeError.hidden = true;
        /* Reset dropdown value */
        if (sizeDdValue) {
          sizeDdValue.textContent = 'Elegir';
          sizeDdValue.classList.add('is-empty');
        }
        closeSizeDd();
        if (colorSelectedLabel) colorSelectedLabel.textContent = '—';
        if (sizesBox) sizesBox.innerHTML = '';
        if (colorPills) colorPills.innerHTML = '';

        var variants = (prize.variants || []).slice();
        var options = prize.options || [];
        /* Filtra "Default Title" (1 variant sin opciones) */
        var hasRealVariants = variants.some(function (v) { return v.title && v.title !== 'Default Title'; });
        if (!hasRealVariants) {
          if (sizesWrap) sizesWrap.hidden = true;
          if (colorPickerWrap) colorPickerWrap.hidden = true;
          if (variants[0]) selectedVariantId = variants[0].id;
          return;
        }

        var idx = detectOptionIdx(options);
        var colorIdx = idx.color, sizeIdx = idx.size;

        /* ===== Color picker ===== */
        if (colorIdx !== -1 && colorPickerWrap && colorPills) {
          var colors = uniqueOptValues(variants, colorIdx);
          if (colors.length > 1) {
            colorPickerWrap.hidden = false;
            colors.forEach(function (cName) {
              var swatch = colorToSwatch(cName);
              /* ¿hay alguna variante disponible con este color? */
              var anyAvail = variants.some(function (v) {
                return v[['option1','option2','option3'][colorIdx]] === cName && v.available;
              });
              var p = document.createElement('button');
              p.type = 'button';
              p.className = 'slot47__color-pill';
              p.setAttribute('role', 'radio');
              p.setAttribute('aria-checked', 'false');
              p.dataset.color = cName;
              if (swatch) p.style.setProperty('--pill-color', swatch);
              p.appendChild(document.createTextNode(cName));
              if (!anyAvail) { p.disabled = true; p.setAttribute('aria-disabled', 'true'); }
              p.addEventListener('click', function () {
                if (p.disabled) return;
                selectedColor = cName;
                selectedSize = null;
                selectedVariantId = null;
                /* Update UI */
                colorPills.querySelectorAll('.slot47__color-pill').forEach(function (x) {
                  x.classList.remove('is-active');
                  x.setAttribute('aria-checked', 'false');
                });
                p.classList.add('is-active');
                p.setAttribute('aria-checked', 'true');
                if (colorSelectedLabel) colorSelectedLabel.textContent = cName;
                if (sizeDdValue) {
                  sizeDdValue.textContent = 'Elegir';
                  sizeDdValue.classList.add('is-empty');
                }
                closeSizeDd();
                renderSizesForColor();
                /* Abre automáticamente el dropdown de tallas para guiar al usuario */
                if (sizesWrap && !sizesWrap.hidden) openSizeDd();
              });
              colorPills.appendChild(p);
            });
            /* Si solo hay 1 color disponible, autoselecciónalo */
            var avails = Array.prototype.slice.call(colorPills.querySelectorAll('.slot47__color-pill:not([disabled])'));
            if (avails.length === 1) avails[0].click();
          } else {
            colorPickerWrap.hidden = true;
            if (colors[0]) selectedColor = colors[0];
          }
        } else if (colorPickerWrap) {
          colorPickerWrap.hidden = true;
        }

        /* ===== Render tallas (depende del color elegido si lo hay) ===== */
        renderSizesForColor();
      }

      function renderSizesForColor() {
        if (!sizesBox || !currentPrize) return;
        sizesBox.innerHTML = '';
        var variants = currentPrize.variants || [];
        var options = currentPrize.options || [];
        var idx = detectOptionIdx(options);
        var colorIdx = idx.color, sizeIdx = idx.size;

        /* Filtra variantes por color elegido (si aplica) */
        var pool = variants;
        if (colorIdx !== -1 && selectedColor) {
          var key = ['option1','option2','option3'][colorIdx];
          pool = variants.filter(function (v) { return v[key] === selectedColor; });
        }

        if (sizeIdx === -1) {
          /* No hay opción de talla · usa la primera del pool */
          if (sizesWrap) sizesWrap.hidden = true;
          if (pool[0]) selectedVariantId = pool[0].id;
          return;
        }

        var sizes = uniqueOptValues(pool, sizeIdx);
        if (!sizes.length) {
          if (sizesWrap) sizesWrap.hidden = true;
          return;
        }
        if (sizesWrap) sizesWrap.hidden = false;

        var sizeKey = ['option1','option2','option3'][sizeIdx];
        sizes.forEach(function (sName) {
          /* ¿está disponible para el color elegido? */
          var v = pool.find ? pool.find(function (x) { return x[sizeKey] === sName; })
                            : pool.filter(function (x) { return x[sizeKey] === sName; })[0];
          if (!v) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'slot47__size';
          b.dataset.variantId = String(v.id);
          b.dataset.size = sName;
          b.textContent = sName;
          b.setAttribute('role', 'option');
          b.setAttribute('aria-selected', 'false');
          if (!v.available) {
            b.disabled = true;
            b.setAttribute('aria-disabled', 'true');
          }
          b.addEventListener('click', function () {
            if (b.disabled) return;
            sizesBox.querySelectorAll('.slot47__size').forEach(function (x) {
              x.classList.remove('is-active');
              x.setAttribute('aria-selected', 'false');
            });
            b.classList.add('is-active');
            b.setAttribute('aria-selected', 'true');
            selectedSize = sName;
            selectedVariantId = parseInt(b.dataset.variantId, 10);
            if (sizeError) sizeError.hidden = true;
            if (sizeDdValue) {
              sizeDdValue.textContent = sName;
              sizeDdValue.classList.remove('is-empty');
            }
            closeSizeDd();
          });
          sizesBox.appendChild(b);
        });
      }

      function postToCart(then) {
        if (!selectedVariantId) {
          if (sizeError) sizeError.hidden = false;
          return;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] })
        }).then(function (r) {
          if (r.ok) { then(); return; }
          return r.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || 'Error al agregar');
          });
        }).catch(function (err) {
          if (sizeError) {
            sizeError.textContent = (err && err.message) || 'Intenta de nuevo';
            sizeError.hidden = false;
          }
        });
      }

      if (buyBtn) {
        buyBtn.addEventListener('click', function () {
          if (!selectedVariantId) {
            if (sizeError) sizeError.hidden = false;
            return;
          }
          buyBtn.disabled = true;
          var prev = buyBtn.querySelector('.slot47__buy-label');
          var prevText = prev ? prev.textContent : 'COMPRAR AHORA';
          if (prev) prev.textContent = 'PROCESANDO…';
          postToCart(function () {
            /* Si hay código de envío gratis · pasar por /discount · luego /checkout */
            if (freeShipCode) {
              window.location.href = '/discount/' + encodeURIComponent(freeShipCode) + '?redirect=/checkout';
            } else {
              window.location.href = '/checkout';
            }
          });
          /* Restore button si nada pasó en 4s */
          setTimeout(function () {
            buyBtn.disabled = false;
            if (prev) prev.textContent = prevText;
          }, 4000);
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (!selectedVariantId) {
            if (sizeError) sizeError.hidden = false;
            return;
          }
          addBtn.disabled = true;
          postToCart(function () {
            if (window.MiniCart47 && typeof window.MiniCart47.refresh === 'function') {
              Promise.resolve(window.MiniCart47.refresh()).then(function () {
                if (typeof window.MiniCart47.open === 'function') window.MiniCart47.open();
              });
            } else {
              document.dispatchEvent(new CustomEvent('cart47:added'));
            }
            addBtn.disabled = false;
          });
        });
      }

      /* IntersectionObserver · pausar pulse cuando offscreen */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            root.classList.toggle('is-offscreen', !e.isIntersecting);
          });
        }, { threshold: 0, rootMargin: '50px 0px' });
        io.observe(root);
      }
    });
  }

  /* ============ STICKY BUY MOBILE 47X · página de producto ============
     Sticky bar abajo · aparece al scroll · talla inline + ATC + mini cart */
  function initStickyBuyMobile47() {
    var bar = document.querySelector('[data-sticky47-buy]');
    if (!bar) return;

    /* Gate explícito · solo móvil/táctil */
    var isMobile = window.matchMedia('(max-width:760px)').matches || (navigator.maxTouchPoints || 0) > 0;
    if (!isMobile) {
      bar.parentNode && bar.parentNode.removeChild(bar);
      return;
    }

    var cta = bar.querySelector('[data-sticky47-cta]');
    var ctaLabel = bar.querySelector('[data-sticky47-cta-label]');
    var sizesWrap = bar.querySelector('[data-sticky47-sizes]');
    var sizesBtns = bar.querySelectorAll('[data-sticky47-size]');
    var errEl = bar.querySelector('[data-sticky47-error]');
    var needsVariants = bar.dataset.needsVariants === 'true';
    var selectedVariantId = parseInt(bar.dataset.variantId, 10) || null;
    var hasSelectedSize = !needsVariants;  /* single-variant ya cuenta como seleccionada */

    /* Sentinel · IntersectionObserver sobre el primer botón ATC nativo
       (#buy-buttons o [data-testid="buy-buttons"]). Si está en pantalla,
       el sticky se esconde · si está fuera, el sticky aparece.
       Fallback: si no encuentra sentinel, usa scrollY > 400. */
    var sentinel = document.querySelector(
      '[data-testid="buy-buttons"], product-form, .buy-buttons, .add-to-cart'
    );

    function show() {
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      /* RAF para asegurar que la transition se enganche */
      requestAnimationFrame(function () { bar.classList.add('is-stuck'); });
    }
    function hide() {
      bar.classList.remove('is-stuck');
      bar.setAttribute('aria-hidden', 'true');
      /* Cerrar tallas si estaban abiertas */
      if (sizesWrap) sizesWrap.hidden = true;
      setTimeout(function () {
        if (!bar.classList.contains('is-stuck')) bar.hidden = true;
      }, 360);
    }

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          /* Bar aparece cuando el ATC nativo NO está visible */
          if (e.isIntersecting) hide(); else show();
        });
      }, { threshold: 0, rootMargin: '-80px 0px -80px 0px' });
      io.observe(sentinel);
    } else {
      /* Fallback scroll · 400px */
      var lastVisible = false;
      function onScroll() {
        var visible = window.scrollY > 400;
        if (visible !== lastVisible) {
          lastVisible = visible;
          if (visible) show(); else hide();
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ── SINCRONIZACIÓN con el selector de talla PRINCIPAL (Horizon) ──
       El sticky refleja la variante elegida en el form real. Si el usuario no ha
       elegido talla → label "ELIGE TU TALLA" y al tocar lleva suavemente al selector.
       Si ya eligió → "AGREGAR A MI BOLSA" y agrega esa variante. */
    var mainForm = document.querySelector('product-form-component form, form[action*="/cart/add"]');
    var mainIdInput = (mainForm && mainForm.querySelector('input[name="id"]'))
      || document.querySelector('product-form-component input[name="id"]');
    var mainPicker = document.querySelector('variant-picker, .variant-option--buttons, [data-testid="variant-picker"]');
    var userPicked = !needsVariants; /* single-variant ya cuenta como elegido */
    var curAvailable = true;

    function readMainVariant() {
      if (mainIdInput && mainIdInput.value) {
        var vid = parseInt(mainIdInput.value, 10);
        if (vid) selectedVariantId = vid;
      }
    }
    function syncLabel() {
      if (!ctaLabel) return;
      if (needsVariants && !userPicked) { ctaLabel.textContent = 'ELIGE TU TALLA'; return; }
      ctaLabel.textContent = curAvailable ? 'AGREGAR A MI BOLSA' : 'AGOTADO';
    }
    function syncPrice() {
      var main = document.querySelector('product-price, .product-information .price, .price:not(.sticky47-buy__price):not([class*="sticky47"])');
      var dest = bar.querySelector('.sticky47-buy__price');
      if (main && dest && main.innerHTML.trim()) dest.innerHTML = main.innerHTML;
    }
    readMainVariant();
    syncLabel();
    document.addEventListener('variant:selected', function () { userPicked = true; syncLabel(); });
    document.addEventListener('variant:update', function (e) {
      userPicked = true;
      if (e && e.detail && e.detail.resource) {
        if (e.detail.resource.id) selectedVariantId = parseInt(e.detail.resource.id, 10) || selectedVariantId;
        if (typeof e.detail.resource.available === 'boolean') curAvailable = e.detail.resource.available;
      }
      readMainVariant();
      syncPrice();
      syncLabel();
    });
    /* fallback: cambios directos en radios del picker principal */
    if (mainPicker) mainPicker.addEventListener('change', function () { userPicked = true; readMainVariant(); syncLabel(); });

    function scrollToMainPicker() {
      var target = mainPicker || document.querySelector('variant-picker, .variant-option');
      if (!target) {
        /* fallback defensivo: sin picker principal, usa las pills del propio sticky */
        if (sizesWrap) { sizesWrap.hidden = false; if (errEl) errEl.hidden = false; }
        return;
      }
      hide();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.add('sticky47-flash');
      setTimeout(function () { target.classList.remove('sticky47-flash'); }, 1300);
    }

    /* Talla picker */
    sizesBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        sizesBtns.forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active');
        b.setAttribute('aria-checked', 'true');
        selectedVariantId = parseInt(b.dataset.variantId, 10);
        hasSelectedSize = true;
        userPicked = true;
        if (errEl) errEl.hidden = true;
        syncLabel();
        /* Auto-trigger compra después de elegir talla (solo fallback sin picker principal) */
        triggerBuy();
      });
    });

    function triggerBuy() {
      readMainVariant();
      if (needsVariants && !userPicked) {
        /* Sin talla elegida → lleva suavemente al selector principal (no compra) */
        scrollToMainPicker();
        return;
      }
      if (!selectedVariantId) return;
      cta.disabled = true;
      var prev = ctaLabel ? ctaLabel.textContent : 'COMPRAR';
      if (ctaLabel) ctaLabel.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) {
          throw new Error((j && (j.description || j.message)) || 'Error');
        });
        return r.json();
      }).then(function () {
        if (window.MiniCart47 && typeof window.MiniCart47.refresh === 'function') {
          return Promise.resolve(window.MiniCart47.refresh()).then(function () {
            if (typeof window.MiniCart47.open === 'function') window.MiniCart47.open();
          });
        }
      }).catch(function () {
        if (errEl) {
          errEl.textContent = 'No se pudo agregar · intenta de nuevo';
          errEl.hidden = false;
        }
      }).finally(function () {
        cta.disabled = false;
        syncLabel();
      });
    }

    if (cta) cta.addEventListener('click', triggerBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // GSAP/Three esperan a 'load' (igual que el prototipo)
  window.addEventListener('load', loadGsapIfNeeded);

  // TODO: cart-drawer real con AJAX Cart API
  //   POST /cart/add.js     · agregar variant
  //   GET  /cart.js         · estado actual
  //   POST /cart/change.js  · cambiar cantidad
  // Se conectará cuando creemos sections/cart-drawer + product-grid.

})();

/* ============================================================
   47X · CART-BUY (cb47) · delegated click handler · global
   - + AGREGAR → despliega tallas
   - talla → AJAX /cart/add.js → abre cart drawer (cart47:open event)
   - × → cierra menú
   - click fuera → cierra menú
   ============================================================ */
/* ============================================================
   47X · VP47 Variant Picker + BN47 Comprar Ahora (delegated handlers)
   - Click TALLA / COLOR → abre panel con pills (genera al primer abrir)
   - Click pill → setea selección · cierra panel · actualiza label
   - Click bn47 (COMPRAR AHORA) → valida selección → AJAX add → drawer open
   - Click fuera o Escape → cierra panel
   ============================================================ */
(function () {
  var CARD_SELECTOR = '.t10__card, .trd47__card, .ofz47__card, .kit47__card, .tmb47__card';

  /* Mapa nombre → swatch hex (best-effort) */
  var SWATCH_MAP = {
    'negro':'#0a0a0a','black':'#0a0a0a','jet':'#0a0a0a','off black':'#1a1a1a',
    'blanco':'#f5f5f5','white':'#f5f5f5','bone':'#ECE5D8','hueso':'#ECE5D8','crema':'#efe6d4',
    'verde':'#39FF14','green':'#39FF14','militar':'#3b4a2a','olive':'#3b4a2a','olivo':'#3b4a2a',
    'rojo':'#dc2626','red':'#dc2626','vino':'#7c1a1a','wine':'#7c1a1a',
    'azul':'#1d4ed8','blue':'#1d4ed8','navy':'#0a1a3a','marino':'#0a1a3a',
    'gris':'#7a7a7a','gray':'#7a7a7a','grey':'#7a7a7a','plomo':'#5a5a5a',
    'cafe':'#5b3a1f','café':'#5b3a1f','brown':'#5b3a1f','marrón':'#5b3a1f','marron':'#5b3a1f',
    'beige':'#d6c7a8','arena':'#d6c7a8','tan':'#d2b48c','khaki':'#c3b091',
    'amarillo':'#fcd34d','yellow':'#fcd34d','dorado':'#d4af37','gold':'#d4af37',
    'rosa':'#ec4899','pink':'#ec4899','rosado':'#ec4899',
    'morado':'#7c3aed','purple':'#7c3aed','lila':'#a78bfa',
    'naranja':'#ea580c','orange':'#ea580c',
    'wash':'#5b5042','acid':'#c8c89f','mezclilla':'#465e7a','denim':'#465e7a'
  };
  function nameToSwatch(name) {
    if (!name) return null;
    var key = String(name).toLowerCase().trim();
    if (SWATCH_MAP[key]) return SWATCH_MAP[key];
    var keys = Object.keys(SWATCH_MAP);
    for (var i = 0; i < keys.length; i++) {
      if (key.indexOf(keys[i]) !== -1) return SWATCH_MAP[keys[i]];
    }
    return null;
  }

  function readVp47Data(vp) {
    if (vp.__vp47Data) return vp.__vp47Data;
    var scriptEl = vp.querySelector('[data-vp47-data]');
    if (!scriptEl) return null;
    try { vp.__vp47Data = JSON.parse(scriptEl.textContent); }
    catch (e) { vp.__vp47Data = null; }
    return vp.__vp47Data;
  }

  function closeAllVp47Panels(except) {
    document.querySelectorAll('[data-vp47]').forEach(function (vp) {
      vp.querySelectorAll('[data-vp47-trigger]').forEach(function (t) {
        if (except && t === except) return;
        t.setAttribute('aria-expanded', 'false');
      });
      vp.querySelectorAll('[data-vp47-panel]').forEach(function (p) {
        if (except && vp.contains(except) && p.getAttribute('data-vp47-panel') === except.getAttribute('data-vp47-trigger')) return;
        p.hidden = true;
      });
    });
  }

  function getOptionKeyFromIdx(idx) {
    return idx === 0 ? 'option1' : idx === 1 ? 'option2' : 'option3';
  }

  function uniqueValuesFor(variants, idx) {
    var seen = {}; var out = [];
    var key = getOptionKeyFromIdx(idx);
    variants.forEach(function (v) {
      var val = v[key];
      if (val && !seen[val]) { seen[val] = true; out.push(val); }
    });
    return out;
  }

  function computeSelectedVariant(vp) {
    var data = readVp47Data(vp);
    if (!data) return null;
    var sizeIdx = parseInt(vp.dataset.sizeIdx, 10);
    var colorIdx = parseInt(vp.dataset.colorIdx, 10);
    var selSize = vp.getAttribute('data-sel-size') || null;
    var selColor = vp.getAttribute('data-sel-color') || null;
    var match = (data.variants || []).filter(function (v) {
      var ok = true;
      if (sizeIdx >= 0 && selSize) ok = ok && v[getOptionKeyFromIdx(sizeIdx)] === selSize;
      if (colorIdx >= 0 && selColor) ok = ok && v[getOptionKeyFromIdx(colorIdx)] === selColor;
      return ok;
    })[0];
    return match || null;
  }

  function updateSelectedVariantOnWrapper(vp) {
    var v = computeSelectedVariant(vp);
    if (v) vp.setAttribute('data-selected-variant', String(v.id));
    else vp.removeAttribute('data-selected-variant');
  }

  function renderPills(vp, field) {
    var data = readVp47Data(vp);
    if (!data) return;
    var pillsBox = vp.querySelector('[data-vp47-pills="' + field + '"]');
    if (!pillsBox) return;
    pillsBox.innerHTML = '';
    var variants = data.variants || [];
    var sizeIdx = parseInt(vp.dataset.sizeIdx, 10);
    var colorIdx = parseInt(vp.dataset.colorIdx, 10);

    /* Pool · si elegimos talla, filtramos colores disponibles por talla · y viceversa */
    var pool = variants.slice();
    if (field === 'size' && colorIdx >= 0) {
      var selColor = vp.getAttribute('data-sel-color');
      if (selColor) pool = pool.filter(function (v) { return v[getOptionKeyFromIdx(colorIdx)] === selColor; });
    } else if (field === 'color' && sizeIdx >= 0) {
      var selSize = vp.getAttribute('data-sel-size');
      if (selSize) pool = pool.filter(function (v) { return v[getOptionKeyFromIdx(sizeIdx)] === selSize; });
    }

    var optIdx = field === 'size' ? sizeIdx : colorIdx;
    if (optIdx < 0) return;
    var values = uniqueValuesFor(variants, optIdx); /* todos los valores · marcamos out por disponibilidad */
    var current = vp.getAttribute(field === 'size' ? 'data-sel-size' : 'data-sel-color') || null;

    values.forEach(function (val) {
      var anyAvailInPool = pool.some(function (v) { return v[getOptionKeyFromIdx(optIdx)] === val && v.available; });
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vp47__pill' + (field === 'color' ? ' vp47__pill--color' : '');
      b.dataset.vp47Pill = field;
      b.dataset.value = val;
      b.setAttribute('role', field === 'color' ? 'radio' : 'option');
      b.setAttribute(field === 'color' ? 'aria-checked' : 'aria-selected', current === val ? 'true' : 'false');
      if (current === val) b.classList.add('is-active');
      if (field === 'color') {
        var swatch = nameToSwatch(val);
        if (swatch) b.style.setProperty('--pill-color', swatch);
      }
      b.appendChild(document.createTextNode(val));
      if (!anyAvailInPool) {
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
      }
      pillsBox.appendChild(b);
    });
  }

  function setSelection(vp, field, value) {
    var attr = field === 'size' ? 'data-sel-size' : 'data-sel-color';
    vp.setAttribute(attr, value);
    var valEl = vp.querySelector('[data-vp47-val="' + field + '"]');
    if (valEl) {
      valEl.textContent = value;
      valEl.classList.remove('is-empty');
    }
    /* Update active state on pills */
    vp.querySelectorAll('[data-vp47-pill="' + field + '"]').forEach(function (p) {
      var match = p.dataset.value === value;
      p.classList.toggle('is-active', match);
      p.setAttribute(field === 'color' ? 'aria-checked' : 'aria-selected', match ? 'true' : 'false');
    });
    /* El otro campo puede tener cambios en disponibilidad · re-render */
    var other = field === 'size' ? 'color' : 'size';
    var otherPanel = vp.querySelector('[data-vp47-panel="' + other + '"]');
    if (otherPanel) renderPills(vp, other);
    /* Recalcula variant id seleccionada */
    updateSelectedVariantOnWrapper(vp);
  }

  function flashPicker(vp, field) {
    var trig = vp.querySelector('[data-vp47-trigger="' + field + '"]');
    if (!trig) return;
    trig.classList.add('vp47__trigger--flash');
    setTimeout(function () { trig.classList.remove('vp47__trigger--flash'); }, 1200);
    /* Y abre el panel */
    closeAllVp47Panels();
    var panel = vp.querySelector('[data-vp47-panel="' + field + '"]');
    if (panel) {
      renderPills(vp, field);
      panel.hidden = false;
      trig.setAttribute('aria-expanded', 'true');
      try { trig.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    /* === VP47 trigger (TALLA / COLOR) === */
    var trigger = e.target.closest('[data-vp47-trigger]');
    if (trigger) {
      e.preventDefault(); e.stopPropagation();
      var field = trigger.getAttribute('data-vp47-trigger');
      var vp = trigger.closest('[data-vp47]');
      var panel = vp.querySelector('[data-vp47-panel="' + field + '"]');
      var wasOpen = !panel.hidden;
      closeAllVp47Panels();
      if (!wasOpen) {
        renderPills(vp, field);
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    /* === VP47 close button === */
    var closeBtn = e.target.closest('[data-vp47-close]');
    if (closeBtn) {
      e.preventDefault(); e.stopPropagation();
      closeAllVp47Panels();
      return;
    }
    /* === VP47 pill (selección de talla o color) === */
    var pill = e.target.closest('[data-vp47-pill]');
    if (pill) {
      e.preventDefault(); e.stopPropagation();
      if (pill.disabled) return;
      var vpx = pill.closest('[data-vp47]');
      var fieldx = pill.dataset.vp47Pill;
      setSelection(vpx, fieldx, pill.dataset.value);
      closeAllVp47Panels();
      return;
    }
    /* === BN47 · HANDLER UNIVERSAL · TODAS las sections del storefront ===
       Flujo único: AJAX add → CartCount47.fetch → MiniCart47.refresh + open
       → reset botón. Sin redirect a /checkout. Sin ramas por section. Cero
       lógica especial para aniversario/p3/drop3 — el usuario decide checkout
       desde el drawer. Validado 2026-06-02. */
    var bn = e.target.closest('[data-bn47]');
    if (bn) {
      e.preventDefault(); e.stopPropagation();
      /* vp47 es sibling de bn47 dentro del card · detección universal sin whitelist
         de clases por section (funciona para t10__card, trd47__card, ofz47__card,
         kit47__card, tmb47__card, a47-X__card, p3-X__card y cualquier section futura). */
      var vpb = bn.parentElement && bn.parentElement.querySelector('[data-vp47]');
      if (!vpb) return;
      /* Verifica que talla + color (si aplica) estén seleccionados */
      var needsColor = vpb.getAttribute('data-has-color') === '1';
      var needsSize = vpb.getAttribute('data-has-size') === '1';
      var hasColor = !!vpb.getAttribute('data-sel-color');
      var hasSize = !!vpb.getAttribute('data-sel-size');
      if (needsColor && !hasColor) { flashPicker(vpb, 'color'); return; }
      if (needsSize && !hasSize) { flashPicker(vpb, 'size'); return; }
      var vid = vpb.getAttribute('data-selected-variant') || vpb.getAttribute('data-default-variant');
      if (!vid) { flashPicker(vpb, needsSize ? 'size' : 'color'); return; }
      /* Add AJAX universal */
      var bnTxt = bn.querySelector('.bn47__txt');
      var originalTxt = bnTxt ? bnTxt.textContent : null;
      bn.classList.add('bn47--loading');
      bn.disabled = true;
      function resetBn() {
        if (bnTxt && originalTxt !== null) bnTxt.textContent = originalTxt;
        bn.classList.remove('bn47--loading');
        bn.disabled = false;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'Agotado'); });
          return r.json();
        })
        .then(function () {
          if (window.CartCount47 && window.CartCount47.fetch) window.CartCount47.fetch();
          /* Universal · refresh cart state + open drawer · mismo método que initAddToMini */
          if (window.MiniCart47) {
            return window.MiniCart47.refresh().then(window.MiniCart47.open).then(resetBn);
          }
          resetBn();
        })
        .catch(function (err) {
          /* Surface error en el botón · "Agotado" o mensaje del server · auto-reset 1.8s */
          if (bnTxt) bnTxt.textContent = (err && err.message) || 'Agotado';
          setTimeout(resetBn, 1800);
        });
      return;
    }
    /* === Click fuera de cualquier vp47 → cierra paneles === */
    if (!e.target.closest('[data-vp47]')) {
      closeAllVp47Panels();
    }
  });

  /* Escape cierra paneles */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllVp47Panels();
  });
})();

/* ============================================================
   47X · CARD47 SYSTEM · 2026-06-03
   Pills inline siempre visibles dentro del slot fijo .card47__variants.
   Click pill → marca activa + filtrado cruzado.
   Click CTA → valida talla+color → /cart/add.js → MiniCart47.open.
   ============================================================ */
(function () {
  var SWATCH_MAP = {
    'negro':'#0a0a0a','black':'#0a0a0a','jet':'#0a0a0a','off black':'#1a1a1a',
    'blanco':'#f5f5f5','white':'#f5f5f5','bone':'#ECE5D8','hueso':'#ECE5D8','crema':'#efe6d4',
    'verde':'#39FF14','green':'#39FF14','militar':'#3b4a2a','olive':'#3b4a2a','olivo':'#3b4a2a',
    'rojo':'#dc2626','red':'#dc2626','vino':'#7c1a1a','wine':'#7c1a1a',
    'azul':'#1d4ed8','blue':'#1d4ed8','navy':'#0a1a3a','marino':'#0a1a3a',
    'gris':'#7a7a7a','gray':'#7a7a7a','grey':'#7a7a7a','plomo':'#5a5a5a',
    'cafe':'#5b3a1f','café':'#5b3a1f','brown':'#5b3a1f','marrón':'#5b3a1f','marron':'#5b3a1f',
    'beige':'#d6c7a8','arena':'#d6c7a8','tan':'#d2b48c','khaki':'#c3b091',
    'amarillo':'#fcd34d','yellow':'#fcd34d','dorado':'#d4af37','gold':'#d4af37',
    'rosa':'#ec4899','pink':'#ec4899','rosado':'#ec4899',
    'morado':'#7c3aed','purple':'#7c3aed','lila':'#a78bfa',
    'naranja':'#ea580c','orange':'#ea580c',
    'wash':'#5b5042','acid':'#c8c89f','mezclilla':'#465e7a','denim':'#465e7a'
  };
  function nameToSwatch(name) {
    if (!name) return null;
    var key = String(name).toLowerCase().trim();
    if (SWATCH_MAP[key]) return SWATCH_MAP[key];
    var keys = Object.keys(SWATCH_MAP);
    for (var i = 0; i < keys.length; i++) {
      if (key.indexOf(keys[i]) !== -1) return SWATCH_MAP[keys[i]];
    }
    return null;
  }
  function optKey(idx) { return idx === 0 ? 'option1' : idx === 1 ? 'option2' : 'option3'; }

  function readData(card) {
    if (card.__card47Data) return card.__card47Data;
    var scriptEl = card.querySelector('[data-card47-data]');
    if (!scriptEl) return null;
    try { card.__card47Data = JSON.parse(scriptEl.textContent); }
    catch (e) { card.__card47Data = null; }
    return card.__card47Data;
  }

  function uniqueValues(variants, idx) {
    var seen = {}; var out = [];
    var k = optKey(idx);
    variants.forEach(function (v) {
      if (v[k] && !seen[v[k]]) { seen[v[k]] = true; out.push(v[k]); }
    });
    return out;
  }

  function computeVariant(card) {
    var data = readData(card);
    if (!data) return null;
    var sIdx = parseInt(card.dataset.sizeIdx, 10);
    var cIdx = parseInt(card.dataset.colorIdx, 10);
    var selS = card.getAttribute('data-sel-size') || null;
    var selC = card.getAttribute('data-sel-color') || null;
    return (data.variants || []).filter(function (v) {
      var ok = true;
      if (sIdx >= 0 && selS) ok = ok && v[optKey(sIdx)] === selS;
      if (cIdx >= 0 && selC) ok = ok && v[optKey(cIdx)] === selC;
      return ok;
    })[0] || null;
  }

  function updateSelectedVid(card) {
    var v = computeVariant(card);
    if (v) card.setAttribute('data-selected-variant', String(v.id));
    else card.removeAttribute('data-selected-variant');
  }

  function renderPills(card, field) {
    var data = readData(card);
    if (!data) return;
    var box = card.querySelector('[data-card47-pills="' + field + '"]');
    if (!box) return;
    box.innerHTML = '';
    var sIdx = parseInt(card.dataset.sizeIdx, 10);
    var cIdx = parseInt(card.dataset.colorIdx, 10);
    var idx = field === 'size' ? sIdx : cIdx;
    if (idx < 0) return;

    var pool = (data.variants || []).slice();
    if (field === 'size' && cIdx >= 0) {
      var selC = card.getAttribute('data-sel-color');
      if (selC) pool = pool.filter(function (v) { return v[optKey(cIdx)] === selC; });
    } else if (field === 'color' && sIdx >= 0) {
      var selS = card.getAttribute('data-sel-size');
      if (selS) pool = pool.filter(function (v) { return v[optKey(sIdx)] === selS; });
    }
    var values = uniqueValues(data.variants, idx);
    var current = card.getAttribute(field === 'size' ? 'data-sel-size' : 'data-sel-color');

    values.forEach(function (val) {
      var anyAvail = pool.some(function (v) { return v[optKey(idx)] === val && v.available; });
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'card47__pill' + (field === 'color' ? ' card47__pill--color' : '');
      b.dataset.card47Pill = field;
      b.dataset.value = val;
      b.setAttribute('role', field === 'color' ? 'radio' : 'option');
      b.setAttribute(field === 'color' ? 'aria-checked' : 'aria-selected', current === val ? 'true' : 'false');
      if (current === val) b.classList.add('is-active');
      if (field === 'color') {
        var sw = nameToSwatch(val);
        if (sw) b.style.setProperty('--pill-color', sw);
      }
      b.appendChild(document.createTextNode(val));
      if (!anyAvail) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
      box.appendChild(b);
    });
  }

  function setSelection(card, field, value) {
    card.setAttribute(field === 'size' ? 'data-sel-size' : 'data-sel-color', value);
    card.querySelectorAll('[data-card47-pill="' + field + '"]').forEach(function (p) {
      var match = p.dataset.value === value;
      p.classList.toggle('is-active', match);
      p.setAttribute(field === 'color' ? 'aria-checked' : 'aria-selected', match ? 'true' : 'false');
    });
    var other = field === 'size' ? 'color' : 'size';
    if (card.querySelector('[data-card47-pills="' + other + '"]')) renderPills(card, other);
    updateSelectedVid(card);
  }

  function flashRow(card, field) {
    var row = card.querySelector('[data-card47-row="' + field + '"]');
    if (!row) return;
    row.classList.add('card47__var-row--flash');
    setTimeout(function () { row.classList.remove('card47__var-row--flash'); }, 1100);
    try { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }

  function buy(card) {
    var needsSize = card.getAttribute('data-has-size') === '1';
    var needsColor = card.getAttribute('data-has-color') === '1';
    var hasSize = !!card.getAttribute('data-sel-size');
    var hasColor = !!card.getAttribute('data-sel-color');
    if (needsSize && !hasSize) { flashRow(card, 'size'); return; }
    if (needsColor && !hasColor) { flashRow(card, 'color'); return; }
    var vid = card.getAttribute('data-selected-variant') || card.getAttribute('data-default-variant');
    if (!vid) { flashRow(card, needsSize ? 'size' : 'color'); return; }

    var btn = card.querySelector('[data-card47-buy]');
    var txt = btn && btn.querySelector('.card47__cta-txt');
    var original = txt ? txt.textContent : null;
    if (btn) { btn.classList.add('card47__cta--loading'); btn.disabled = true; }
    function reset() {
      if (txt && original !== null) txt.textContent = original;
      if (btn) { btn.classList.remove('card47__cta--loading'); btn.disabled = false; }
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'Agotado'); });
        return r.json();
      })
      .then(function () {
        if (window.CartCount47 && window.CartCount47.fetch) window.CartCount47.fetch();
        if (window.MiniCart47) {
          return window.MiniCart47.refresh().then(window.MiniCart47.open).then(reset);
        }
        reset();
      })
      .catch(function (err) {
        if (txt) txt.textContent = (err && err.message) || 'Agotado';
        setTimeout(reset, 1800);
      });
  }

  function initAll() {
    document.querySelectorAll('[data-card47]').forEach(function (c) {
      if (c.getAttribute('data-has-size') === '1') renderPills(c, 'size');
      if (c.getAttribute('data-has-color') === '1') renderPills(c, 'color');
      updateSelectedVid(c);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-card47-pill]');
    if (pill) {
      e.preventDefault(); e.stopPropagation();
      if (pill.disabled) return;
      var card = pill.closest('[data-card47]');
      if (card) setSelection(card, pill.dataset.card47Pill, pill.dataset.value);
      return;
    }
    var btn = e.target.closest('[data-card47-buy]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var card2 = btn.closest('[data-card47]');
      if (card2) buy(card2);
      return;
    }
  });
})();

/* ===================================================================
   PERF · WARM-AHEAD de imágenes lazy: precalienta en caché las <img loading="lazy">
   ~1200px ANTES de que entren en pantalla → aparecen al instante al bajar/scrollear
   (las tarjetas de producto de los rails, categorías, etc.). No toca el markup ni
   cambia el src del <img>; solo pre-descarga el mismo recurso responsivo a caché.
   =================================================================== */
(function () {
  if (!('IntersectionObserver' in window)) return;
  function force(img) {
    /* fuerza al <img> REAL a cargar ya (no un preload paralelo → sin dobles descargas ni fallos de caché) */
    if (img.dataset.warm) return;
    img.dataset.warm = '1';
    try {
      img.loading = 'eager';
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
      /* re-dispara la carga REAL de forma fiable: quitar+reponer srcset obliga al
         navegador a re-evaluar (re-asignar el mismo src no siempre dispara carga) */
      if (!img.complete) {
        var ss = img.getAttribute('srcset');
        if (ss) { img.removeAttribute('srcset'); img.setAttribute('srcset', ss); }
        var s = img.getAttribute('src');
        if (s) { img.setAttribute('src', s); }
      }
    } catch (x) {}
  }
  var io = new IntersectionObserver(function (entries) {
    for (var k = 0; k < entries.length; k++) {
      if (!entries[k].isIntersecting) continue;
      var img = entries[k].target;
      io.unobserve(img);
      force(img);
    }
  }, { rootMargin: '2400px 800px' });

  function scan() {
    var imgs = document.querySelectorAll('img[loading="lazy"]:not([data-warm])');
    for (var i = 0; i < imgs.length; i++) io.observe(imgs[i]);
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  /* re-escanea por si se inyectan tarjetas después (rails, filtros, "cargar más") */
  window.addEventListener('load', function () { setTimeout(scan, 600); });
})();


/* ============================================================
   47X · CARD47 · flip y portadas en video
   Antes iban en dos <script> dentro del snippet, o sea una copia por
   card. Los dos ya traian candado (__card47flip / __card47vid) asi que
   solo se ejecutaban una vez; lo que sobraba eran los bytes. 47x.js se
   carga con defer, o sea que corre con el DOM ya parseado.
   ============================================================ */
(function(){
  if(window.__card47flip) return; window.__card47flip=1;
  document.addEventListener('click',function(e){
    var b=e.target.closest && e.target.closest('[data-card47-flip]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var card=b.closest('.card47'); if(card) card.classList.toggle('is-flipped');
  },true);
})();

(function(){
  /* Portadas en video de las cards.
     El objetivo es que la card NUNCA se vea negra ni haga esperar:
       1. La descarga arranca 700px ANTES de que la card entre a pantalla, para que
          cuando la veas ya tenga cuadros listos. Antes empezaba a bajar recien
          cuando ya estaba 35% visible, y ahi si se notaba el retraso.
       2. El video solo se hace visible en el evento 'playing', o sea cuando de
          verdad esta pintando. Hasta entonces se ve la foto del producto.
       3. Una vez encendido se queda encendido: al salir de pantalla se pausa para
          no gastar bateria, pero NO se oculta, asi al volver reanuda al instante
          sin parpadeo. */
  if(window.__card47vid) return; window.__card47vid=1;
  function boot(){
    var vs=document.querySelectorAll('[data-card47-vid]'); if(!vs.length) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches){
      vs.forEach(function(v){ v.removeAttribute('src'); v.innerHTML=''; }); return;
    }
    if(!('IntersectionObserver' in window)) return;

    function arranca(v){
      if(v.__on) return; v.__on=1;
      v.preload='auto';
      try{ v.load(); }catch(e){}
      var go=function(){ var p=v.play&&v.play(); if(p&&p.catch) p.catch(function(){}); };
      /* readyState 3 = ya hay cuadros suficientes para reproducir sin cortar */
      if(v.readyState>=3) go(); else v.addEventListener('canplay',go,{once:true});
    }

    /* 1 · precarga anticipada: se adelanta a la vista */
    var pre=new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ arranca(x.target); pre.unobserve(x.target); } });
    },{rootMargin:'700px 0px'});

    /* 2 · play/pause segun se vea de verdad */
    var vis=new IntersectionObserver(function(en){
      en.forEach(function(x){
        var v=x.target;
        if(x.isIntersecting){ arranca(v); var p=v.play&&v.play(); if(p&&p.catch) p.catch(function(){}); }
        else if(v.__on){ v.pause&&v.pause(); }
      });
    },{threshold:.15});

    vs.forEach(function(v){ pre.observe(v); vis.observe(v); });
  }
  /* Sin esperar a window.load ni a idle: el observador no descarga nada por si mismo,
     lo que gobierna el gasto es el rootMargin de arriba. Esperar 1.5s solo garantizaba
     que las primeras cards llegaran tarde. */
  (document.readyState==='loading')?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
})();



/* ============================================================
   47X · VIDEOS AUTOPLAY · pausar los que no se ven
   El home trae 4 videos con autoplay (hero, banner del drop y 2 de categorías).
   Ninguna de esas secciones los pausaba, así que los cuatro seguían decodificando
   aunque el visitante ya hubiera bajado: CPU y batería gastadas en algo invisible,
   que en un celular de gama media se siente como tirones al hacer scroll.
   Al volver a entrar en pantalla reanudan solos. Son muted+loop, así que el
   corte no se nota. Con "Reducir movimiento" activado no se tocan: esa decisión
   ya la toman las secciones.
   ============================================================ */
(function () {
  if (window.__vid47pause) return; window.__vid47pause = 1;
  function boot() {
    if (!('IntersectionObserver' in window)) return;
    var vs = document.querySelectorAll('video[autoplay]');
    if (!vs.length) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var v = x.target;
        try {
          if (x.isIntersecting) {
            if (v.__pausado47) { v.__pausado47 = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else if (!v.paused) {
            v.__pausado47 = 1; v.pause();
          }
        } catch (e) {}
      });
    }, { threshold: 0.01 });
    for (var i = 0; i < vs.length; i++) io.observe(vs[i]);
  }
  (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', boot, { once: true })
    : boot();
})();
